(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode('@charset "UTF-8";._tooltip_5svgn_1{width:260px}._popover_5svgn_5{background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);box-sizing:border-box;z-index:100}._bar_1n5dj_1{overflow:hidden}._section_1n5dj_5{position:relative}._sectionHidden_1n5dj_8{display:none!important}._sectionInheritRadius_1n5dj_11{border-radius:inherit}._valueOutside_1n5dj_15{position:absolute;left:calc(100% + var(--dixa-size-spacer-100));z-index:1}:root{--dixa-analytics-color-default-1: var(--dixa-color-purple-700);--dixa-analytics-color-default-2: var(--dixa-color-blue-300);--dixa-analytics-color-default-3: var(--dixa-color-red-500);--dixa-analytics-color-default-4: var(--dixa-color-orange-300);--dixa-analytics-color-default-5: var(--dixa-color-purple-500);--dixa-analytics-color-default-6: var(--dixa-color-green-400);--dixa-analytics-color-default-7: var(--dixa-color-neutral-600);--dixa-analytics-color-default-8: var(--dixa-color-neutral-400);--dixa-analytics-color-rating-1: var(--dixa-color-red-600);--dixa-analytics-color-rating-2: var(--dixa-color-red-400);--dixa-analytics-color-rating-3: var(--dixa-color-orange-300);--dixa-analytics-color-rating-4: var(--dixa-color-green-500);--dixa-analytics-color-rating-5: var(--dixa-color-green-600)}[data-color-mode=dark]{--dixa-analytics-color-default-1: var(--dixa-color-blue-300);--dixa-analytics-color-default-2: var(--dixa-color-blue-700);--dixa-analytics-color-default-3: var(--dixa-color-red-400);--dixa-analytics-color-default-4: var(--dixa-color-orange-600);--dixa-analytics-color-default-5: var(--dixa-color-purple-500);--dixa-analytics-color-default-6: var(--dixa-color-green-500);--dixa-analytics-color-default-7: var(--dixa-color-neutral-400);--dixa-analytics-color-default-8: var(--dixa-color-neutral-800);--dixa-analytics-color-rating-1: var(--dixa-color-red-400);--dixa-analytics-color-rating-2: var(--dixa-color-red-600);--dixa-analytics-color-rating-3: var(--dixa-color-orange-600);--dixa-analytics-color-rating-4: var(--dixa-color-green-400);--dixa-analytics-color-rating-5: var(--dixa-color-green-300)}._container_1t2a7_1{overflow:hidden}._root_6kwn9_1{display:grid;column-gap:var(--dixa-size-spacer-200);row-gap:var(--dixa-size-spacer-300);white-space:nowrap}._root_6kwn9_1:not(._rootBounded_6kwn9_7):not(._rootFluid_6kwn9_7){grid-template-columns:repeat(auto-fit,minmax(min(100% / 2 - var(--dixa-size-spacer-200) * (2 - 1) / 2,max(96px,100% / 6 - var(--dixa-size-spacer-200) * (6 - 1) / 6)),1fr))}._rootFluid_6kwn9_7,._rootBounded_6kwn9_7{grid-template-columns:repeat(auto-fit,minmax(96px,1fr))}._rootBounded_6kwn9_7{max-width:calc(6 * 96px + var(--dixa-size-spacer-200) * (6 - 1))}._wrapper_1w7q6_1{display:inline-flex;align-self:flex-start}._text_1w7q6_6{font-size:var(--dixa-typography-size-600)}._colorIndicator_luubh_1{width:6px;height:6px;border-radius:50%;flex-shrink:0}._root_on75o_54{display:flex;flex-direction:column;gap:var(--dixa-size-spacer-300);padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);box-shadow:var(--dixa-effect-box-shadow-300);background-color:light-dark(var(--dixa-color-neutral-900),var(--dixa-color-neutral-200));color:light-dark(var(--dixa-color-neutral-000),var(--dixa-typography-color-primary))}@supports not (color: light-dark(white,black)){._root_on75o_54{background-color:var(--dixa-color-neutral-900)}}@supports not (color: light-dark(white,black)){._root_on75o_54{color:var(--dixa-color-neutral-000)}}._legendItem_15b15_54{flex-shrink:0;overflow:hidden;white-space:nowrap;cursor:pointer;opacity:1}._legendItemInactive_15b15_61{opacity:.4}._legendIcon_15b15_65{flex-shrink:0;width:12px;border-radius:var(--dixa-size-border-radius-50);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-sizing:border-box}._legendIconBar_15b15_72{height:12px}._legendIconLine_15b15_75{height:4px}._trigger_1mrk9_1{width:100%;height:100%}._cell_hfkay_1{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;cursor:default;opacity:1;transition:opacity .2s ease-in-out}._cell_hfkay_1:hover ._cellText_hfkay_11{color:var(--dixa-typography-color-primary)}._cellDimmed_hfkay_14{opacity:var(--dixa-effect-opacity-200)}._cellContent_hfkay_18{display:flex;align-items:center;justify-content:center;width:100%;height:100%}._cellText_hfkay_11{transition:color .2s ease-in-out}._grid_1qk2p_1{display:grid;grid-auto-rows:minmax(var(--dixa-size-spacer-500),1fr);flex-grow:1}._row_1qk2p_7{display:grid;grid-auto-columns:1fr;grid-auto-flow:column;align-items:center;text-align:center}._legend_1k9xu_54{position:relative}._trigger_1k9xu_58{position:absolute;top:-50%;right:0}._popover_1k9xu_64{width:256px;max-height:298px;padding:var(--dixa-size-spacer-300);z-index:100;box-sizing:border-box;background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);margin:0 var(--dixa-size-spacer-200);overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._breakdown_1k9xu_83{display:flex;flex-direction:column;gap:var(--dixa-size-spacer-250);list-style:none;margin:0;padding:0}._breakdown_1k9xu_83 li{display:grid;grid-template-columns:1fr auto;gap:var(--dixa-size-spacer-200)}._breakdown_1k9xu_83 li>:first-child{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_h4i5v_1{max-width:300px}._trigger_h4i5v_5{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0}._tableWrapper_1xmkm_1{overflow:auto}._tableWrapperEmpty_1xmkm_4{flex-grow:1}._thCell_1xmkm_8{white-space:nowrap}._tdCell_1xmkm_12{position:relative;max-width:240px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_1xmkm_20{max-width:300px}')),document.head.appendChild(a)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import * as D from "react";
import no, { useCallback as U, createContext as Ct, useMemo as W, createElement as V, useContext as ao, forwardRef as se, Children as ct, isValidElement as Zt, cloneElement as lr, Fragment as Tl, useEffect as X, useRef as ee, useState as te, useLayoutEffect as Pt, useReducer as dd, memo as ye } from "react";
import { IconButton as io, ButtonList as Tr, FlexBox as J, Text as Y, Tooltip as Et, Box as oo, ButtonGroup as so, Button as co, EmptyState as ql, Divider as hd, Badge as pd, Table as Ce, HelpIcon as vd, Pagination as gd } from "@dixa/lib-shared-habla";
import * as md from "react-dom";
import bd, { flushSync as jl } from "react-dom";
import je from "classnames";
import { usePrevious as Il, useInterval as yd, useList as _d, useUpdateEffect as Ot, useMap as xd } from "react-use";
import { Sector as Ho, LabelList as wd, Cell as zo, ResponsiveContainer as Cd, XAxis as Rd, YAxis as Sd, CartesianGrid as $d, ReferenceLine as Pd, Label as Ed, Legend as Od, Tooltip as Ad, PieChart as Td, AreaChart as qd, LineChart as jd, BarChart as Id, Line as Md, Bar as Dd, Area as Fd, Pie as Nd } from "recharts";
import ut from "moment-timezone";
import { colors as Ml, typography as kd } from "@dixa/lib-shared-tokens";
import { TagChips as Ld } from "lib-shared-tagging";
var Ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Re(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Bd(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      var a = !1;
      try {
        a = this instanceof n;
      } catch {
      }
      return a ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Nt = { exports: {} }, vt = {};
var Uo;
function Vd() {
  if (Uo) return vt;
  Uo = 1;
  var e = no, t = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, c, u) {
    var h, l = {}, d = null, f = null;
    u !== void 0 && (d = "" + u), c.key !== void 0 && (d = "" + c.key), c.ref !== void 0 && (f = c.ref);
    for (h in c) n.call(c, h) && !i.hasOwnProperty(h) && (l[h] = c[h]);
    if (s && s.defaultProps) for (h in c = s.defaultProps, c) l[h] === void 0 && (l[h] = c[h]);
    return { $$typeof: t, type: s, key: d, ref: f, props: l, _owner: a.current };
  }
  return vt.Fragment = r, vt.jsx = o, vt.jsxs = o, vt;
}
var gt = {};
var Wo;
function Hd() {
  return Wo || (Wo = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = no, t = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), i = /* @__PURE__ */ Symbol.for("react.profiler"), o = /* @__PURE__ */ Symbol.for("react.provider"), s = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), u = /* @__PURE__ */ Symbol.for("react.suspense"), h = /* @__PURE__ */ Symbol.for("react.suspense_list"), l = /* @__PURE__ */ Symbol.for("react.memo"), d = /* @__PURE__ */ Symbol.for("react.lazy"), f = /* @__PURE__ */ Symbol.for("react.offscreen"), g = Symbol.iterator, p = "@@iterator";
    function m(v) {
      if (v === null || typeof v != "object")
        return null;
      var O = g && v[g] || v[p];
      return typeof O == "function" ? O : null;
    }
    var y = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(v) {
      {
        for (var O = arguments.length, j = new Array(O > 1 ? O - 1 : 0), k = 1; k < O; k++)
          j[k - 1] = arguments[k];
        R("error", v, j);
      }
    }
    function R(v, O, j) {
      {
        var k = y.ReactDebugCurrentFrame, z = k.getStackAddendum();
        z !== "" && (O += "%s", j = j.concat([z]));
        var K = j.map(function(H) {
          return String(H);
        });
        K.unshift("Warning: " + O), Function.prototype.apply.call(console[v], console, K);
      }
    }
    var C = !1, S = !1, P = !1, T = !1, w = !1, x;
    x = /* @__PURE__ */ Symbol.for("react.module.reference");
    function E(v) {
      return !!(typeof v == "string" || typeof v == "function" || v === n || v === i || w || v === a || v === u || v === h || T || v === f || C || S || P || typeof v == "object" && v !== null && (v.$$typeof === d || v.$$typeof === l || v.$$typeof === o || v.$$typeof === s || v.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      v.$$typeof === x || v.getModuleId !== void 0));
    }
    function $(v, O, j) {
      var k = v.displayName;
      if (k)
        return k;
      var z = O.displayName || O.name || "";
      return z !== "" ? j + "(" + z + ")" : j;
    }
    function I(v) {
      return v.displayName || "Context";
    }
    function A(v) {
      if (v == null)
        return null;
      if (typeof v.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof v == "function")
        return v.displayName || v.name || null;
      if (typeof v == "string")
        return v;
      switch (v) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case u:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case s:
            var O = v;
            return I(O) + ".Consumer";
          case o:
            var j = v;
            return I(j._context) + ".Provider";
          case c:
            return $(v, v.render, "ForwardRef");
          case l:
            var k = v.displayName || null;
            return k !== null ? k : A(v.type) || "Memo";
          case d: {
            var z = v, K = z._payload, H = z._init;
            try {
              return A(H(K));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, F = 0, M, N, L, G, ne, ae, ce;
    function oe() {
    }
    oe.__reactDisabledLog = !0;
    function ue() {
      {
        if (F === 0) {
          M = console.log, N = console.info, L = console.warn, G = console.error, ne = console.group, ae = console.groupCollapsed, ce = console.groupEnd;
          var v = {
            configurable: !0,
            enumerable: !0,
            value: oe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: v,
            log: v,
            warn: v,
            error: v,
            group: v,
            groupCollapsed: v,
            groupEnd: v
          });
        }
        F++;
      }
    }
    function ve() {
      {
        if (F--, F === 0) {
          var v = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, v, {
              value: M
            }),
            info: q({}, v, {
              value: N
            }),
            warn: q({}, v, {
              value: L
            }),
            error: q({}, v, {
              value: G
            }),
            group: q({}, v, {
              value: ne
            }),
            groupCollapsed: q({}, v, {
              value: ae
            }),
            groupEnd: q({}, v, {
              value: ce
            })
          });
        }
        F < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Z = y.ReactCurrentDispatcher, ge;
    function de(v, O, j) {
      {
        if (ge === void 0)
          try {
            throw Error();
          } catch (z) {
            var k = z.stack.trim().match(/\n( *(at )?)/);
            ge = k && k[1] || "";
          }
        return `
` + ge + v;
      }
    }
    var ie = !1, _e;
    {
      var Ae = typeof WeakMap == "function" ? WeakMap : Map;
      _e = new Ae();
    }
    function Ne(v, O) {
      if (!v || ie)
        return "";
      {
        var j = _e.get(v);
        if (j !== void 0)
          return j;
      }
      var k;
      ie = !0;
      var z = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var K;
      K = Z.current, Z.current = null, ue();
      try {
        if (O) {
          var H = function() {
            throw Error();
          };
          if (Object.defineProperty(H.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(H, []);
            } catch (pe) {
              k = pe;
            }
            Reflect.construct(v, [], H);
          } else {
            try {
              H.call();
            } catch (pe) {
              k = pe;
            }
            v.call(H.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (pe) {
            k = pe;
          }
          v();
        }
      } catch (pe) {
        if (pe && k && typeof pe.stack == "string") {
          for (var B = pe.stack.split(`
`), fe = k.stack.split(`
`), Q = B.length - 1, re = fe.length - 1; Q >= 1 && re >= 0 && B[Q] !== fe[re]; )
            re--;
          for (; Q >= 1 && re >= 0; Q--, re--)
            if (B[Q] !== fe[re]) {
              if (Q !== 1 || re !== 1)
                do
                  if (Q--, re--, re < 0 || B[Q] !== fe[re]) {
                    var xe = `
` + B[Q].replace(" at new ", " at ");
                    return v.displayName && xe.includes("<anonymous>") && (xe = xe.replace("<anonymous>", v.displayName)), typeof v == "function" && _e.set(v, xe), xe;
                  }
                while (Q >= 1 && re >= 0);
              break;
            }
        }
      } finally {
        ie = !1, Z.current = K, ve(), Error.prepareStackTrace = z;
      }
      var rt = v ? v.displayName || v.name : "", ze = rt ? de(rt) : "";
      return typeof v == "function" && _e.set(v, ze), ze;
    }
    function he(v, O, j) {
      return Ne(v, !1);
    }
    function Te(v) {
      var O = v.prototype;
      return !!(O && O.isReactComponent);
    }
    function le(v, O, j) {
      if (v == null)
        return "";
      if (typeof v == "function")
        return Ne(v, Te(v));
      if (typeof v == "string")
        return de(v);
      switch (v) {
        case u:
          return de("Suspense");
        case h:
          return de("SuspenseList");
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case c:
            return he(v.render);
          case l:
            return le(v.type, O, j);
          case d: {
            var k = v, z = k._payload, K = k._init;
            try {
              return le(K(z), O, j);
            } catch {
            }
          }
        }
      return "";
    }
    var ke = Object.prototype.hasOwnProperty, Mt = {}, Dt = y.ReactDebugCurrentFrame;
    function Qe(v) {
      if (v) {
        var O = v._owner, j = le(v.type, v._source, O ? O.type : null);
        Dt.setExtraStackFrame(j);
      } else
        Dt.setExtraStackFrame(null);
    }
    function Sr(v, O, j, k, z) {
      {
        var K = Function.call.bind(ke);
        for (var H in v)
          if (K(v, H)) {
            var B = void 0;
            try {
              if (typeof v[H] != "function") {
                var fe = Error((k || "React class") + ": " + j + " type `" + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[H] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw fe.name = "Invariant Violation", fe;
              }
              B = v[H](O, H, k, j, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Q) {
              B = Q;
            }
            B && !(B instanceof Error) && (Qe(z), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", j, H, typeof B), Qe(null)), B instanceof Error && !(B.message in Mt) && (Mt[B.message] = !0, Qe(z), _("Failed %s type: %s", j, B.message), Qe(null));
          }
      }
    }
    var et = Array.isArray;
    function $r(v) {
      return et(v);
    }
    function Wf(v) {
      {
        var O = typeof Symbol == "function" && Symbol.toStringTag, j = O && v[Symbol.toStringTag] || v.constructor.name || "Object";
        return j;
      }
    }
    function Gf(v) {
      try {
        return To(v), !1;
      } catch {
        return !0;
      }
    }
    function To(v) {
      return "" + v;
    }
    function qo(v) {
      if (Gf(v))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Wf(v)), To(v);
    }
    var jo = y.ReactCurrentOwner, Kf = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Io, Mo;
    function Yf(v) {
      if (ke.call(v, "ref")) {
        var O = Object.getOwnPropertyDescriptor(v, "ref").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return v.ref !== void 0;
    }
    function Xf(v) {
      if (ke.call(v, "key")) {
        var O = Object.getOwnPropertyDescriptor(v, "key").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return v.key !== void 0;
    }
    function Jf(v, O) {
      typeof v.ref == "string" && jo.current;
    }
    function Zf(v, O) {
      {
        var j = function() {
          Io || (Io = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        j.isReactWarning = !0, Object.defineProperty(v, "key", {
          get: j,
          configurable: !0
        });
      }
    }
    function Qf(v, O) {
      {
        var j = function() {
          Mo || (Mo = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        j.isReactWarning = !0, Object.defineProperty(v, "ref", {
          get: j,
          configurable: !0
        });
      }
    }
    var ed = function(v, O, j, k, z, K, H) {
      var B = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: v,
        key: O,
        ref: j,
        props: H,
        // Record the component responsible for creating this element.
        _owner: K
      };
      return B._store = {}, Object.defineProperty(B._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(B, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(B, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: z
      }), Object.freeze && (Object.freeze(B.props), Object.freeze(B)), B;
    };
    function td(v, O, j, k, z) {
      {
        var K, H = {}, B = null, fe = null;
        j !== void 0 && (qo(j), B = "" + j), Xf(O) && (qo(O.key), B = "" + O.key), Yf(O) && (fe = O.ref, Jf(O, z));
        for (K in O)
          ke.call(O, K) && !Kf.hasOwnProperty(K) && (H[K] = O[K]);
        if (v && v.defaultProps) {
          var Q = v.defaultProps;
          for (K in Q)
            H[K] === void 0 && (H[K] = Q[K]);
        }
        if (B || fe) {
          var re = typeof v == "function" ? v.displayName || v.name || "Unknown" : v;
          B && Zf(H, re), fe && Qf(H, re);
        }
        return ed(v, B, fe, z, k, jo.current, H);
      }
    }
    var Pr = y.ReactCurrentOwner, Do = y.ReactDebugCurrentFrame;
    function tt(v) {
      if (v) {
        var O = v._owner, j = le(v.type, v._source, O ? O.type : null);
        Do.setExtraStackFrame(j);
      } else
        Do.setExtraStackFrame(null);
    }
    var Er;
    Er = !1;
    function Or(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }
    function Fo() {
      {
        if (Pr.current) {
          var v = A(Pr.current.type);
          if (v)
            return `

Check the render method of \`` + v + "`.";
        }
        return "";
      }
    }
    function rd(v) {
      return "";
    }
    var No = {};
    function nd(v) {
      {
        var O = Fo();
        if (!O) {
          var j = typeof v == "string" ? v : v.displayName || v.name;
          j && (O = `

Check the top-level render call using <` + j + ">.");
        }
        return O;
      }
    }
    function ko(v, O) {
      {
        if (!v._store || v._store.validated || v.key != null)
          return;
        v._store.validated = !0;
        var j = nd(O);
        if (No[j])
          return;
        No[j] = !0;
        var k = "";
        v && v._owner && v._owner !== Pr.current && (k = " It was passed a child from " + A(v._owner.type) + "."), tt(v), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', j, k), tt(null);
      }
    }
    function Lo(v, O) {
      {
        if (typeof v != "object")
          return;
        if ($r(v))
          for (var j = 0; j < v.length; j++) {
            var k = v[j];
            Or(k) && ko(k, O);
          }
        else if (Or(v))
          v._store && (v._store.validated = !0);
        else if (v) {
          var z = m(v);
          if (typeof z == "function" && z !== v.entries)
            for (var K = z.call(v), H; !(H = K.next()).done; )
              Or(H.value) && ko(H.value, O);
        }
      }
    }
    function ad(v) {
      {
        var O = v.type;
        if (O == null || typeof O == "string")
          return;
        var j;
        if (typeof O == "function")
          j = O.propTypes;
        else if (typeof O == "object" && (O.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        O.$$typeof === l))
          j = O.propTypes;
        else
          return;
        if (j) {
          var k = A(O);
          Sr(j, v.props, "prop", k, v);
        } else if (O.PropTypes !== void 0 && !Er) {
          Er = !0;
          var z = A(O);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", z || "Unknown");
        }
        typeof O.getDefaultProps == "function" && !O.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function id(v) {
      {
        for (var O = Object.keys(v.props), j = 0; j < O.length; j++) {
          var k = O[j];
          if (k !== "children" && k !== "key") {
            tt(v), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), tt(null);
            break;
          }
        }
        v.ref !== null && (tt(v), _("Invalid attribute `ref` supplied to `React.Fragment`."), tt(null));
      }
    }
    var Bo = {};
    function Vo(v, O, j, k, z, K) {
      {
        var H = E(v);
        if (!H) {
          var B = "";
          (v === void 0 || typeof v == "object" && v !== null && Object.keys(v).length === 0) && (B += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var fe = rd();
          fe ? B += fe : B += Fo();
          var Q;
          v === null ? Q = "null" : $r(v) ? Q = "array" : v !== void 0 && v.$$typeof === t ? (Q = "<" + (A(v.type) || "Unknown") + " />", B = " Did you accidentally export a JSX literal instead of a component?") : Q = typeof v, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Q, B);
        }
        var re = td(v, O, j, z, K);
        if (re == null)
          return re;
        if (H) {
          var xe = O.children;
          if (xe !== void 0)
            if (k)
              if ($r(xe)) {
                for (var rt = 0; rt < xe.length; rt++)
                  Lo(xe[rt], v);
                Object.freeze && Object.freeze(xe);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Lo(xe, v);
        }
        if (ke.call(O, "key")) {
          var ze = A(v), pe = Object.keys(O).filter(function(fd) {
            return fd !== "key";
          }), Ar = pe.length > 0 ? "{key: someKey, " + pe.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Bo[ze + Ar]) {
            var ld = pe.length > 0 ? "{" + pe.join(": ..., ") + ": ...}" : "{}";
            _(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ar, ze, ld, ze), Bo[ze + Ar] = !0;
          }
        }
        return v === n ? id(re) : ad(re), re;
      }
    }
    function od(v, O, j) {
      return Vo(v, O, j, !0);
    }
    function sd(v, O, j) {
      return Vo(v, O, j, !1);
    }
    var cd = sd, ud = od;
    gt.Fragment = n, gt.jsx = cd, gt.jsxs = ud;
  })()), gt;
}
var Go;
function zd() {
  return Go || (Go = 1, process.env.NODE_ENV === "production" ? Nt.exports = Vd() : Nt.exports = Hd()), Nt.exports;
}
var b = zd();
function Pe() {
  return Pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pe.apply(this, arguments);
}
function Gt(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e?.(a), r === !1 || !a.defaultPrevented) return t?.(a);
  };
}
function Ud(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Wd(...e) {
  return (t) => e.forEach(
    (r) => Ud(r, t)
  );
}
function uo(...e) {
  return U(Wd(...e), e);
}
function Gd(e, t = []) {
  let r = [];
  function n(i, o) {
    const s = /* @__PURE__ */ Ct(o), c = r.length;
    r = [
      ...r,
      o
    ];
    function u(l) {
      const { scope: d, children: f, ...g } = l, p = d?.[e][c] || s, m = W(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ V(p.Provider, {
        value: m
      }, f);
    }
    function h(l, d) {
      const f = d?.[e][c] || s, g = ao(f);
      if (g) return g;
      if (o !== void 0) return o;
      throw new Error(`\`${l}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [
      u,
      h
    ];
  }
  const a = () => {
    const i = r.map((o) => /* @__PURE__ */ Ct(o));
    return function(s) {
      const c = s?.[e] || i;
      return W(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    n,
    Kd(a, ...t)
  ];
}
function Kd(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = n.reduce((s, { useScope: c, scopeName: u }) => {
        const l = c(i)[`__scope${u}`];
        return {
          ...s,
          ...l
        };
      }, {});
      return W(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return r.scopeName = t.scopeName, r;
}
function Qt() {
  return Qt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qt.apply(this, arguments);
}
function qr(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e?.(a), r === !1 || !a.defaultPrevented) return t?.(a);
  };
}
function er() {
  return er = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, er.apply(this, arguments);
}
function Yd(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Xd(...e) {
  return (t) => e.forEach(
    (r) => Yd(r, t)
  );
}
const Ke = /* @__PURE__ */ se((e, t) => {
  const { children: r, ...n } = e, a = ct.toArray(r), i = a.find(Zd);
  if (i) {
    const o = i.props.children, s = a.map((c) => c === i ? ct.count(o) > 1 ? ct.only(null) : /* @__PURE__ */ Zt(o) ? o.props.children : null : c);
    return /* @__PURE__ */ V(Ki, er({}, n, {
      ref: t
    }), /* @__PURE__ */ Zt(o) ? /* @__PURE__ */ lr(o, void 0, s) : null);
  }
  return /* @__PURE__ */ V(Ki, er({}, n, {
    ref: t
  }), r);
});
Ke.displayName = "Slot";
const Ki = /* @__PURE__ */ se((e, t) => {
  const { children: r, ...n } = e;
  return /* @__PURE__ */ Zt(r) ? /* @__PURE__ */ lr(r, {
    ...Qd(n, r.props),
    ref: t ? Xd(t, r.ref) : r.ref
  }) : ct.count(r) > 1 ? ct.only(null) : null;
});
Ki.displayName = "SlotClone";
const Jd = ({ children: e }) => /* @__PURE__ */ V(Tl, null, e);
function Zd(e) {
  return /* @__PURE__ */ Zt(e) && e.type === Jd;
}
function Qd(e, t) {
  const r = {
    ...t
  };
  for (const n in t) {
    const a = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...s) => {
      i(...s), a(...s);
    } : a && (r[n] = a) : n === "style" ? r[n] = {
      ...a,
      ...i
    } : n === "className" && (r[n] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...r
  };
}
const eh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], th = eh.reduce((e, t) => {
  const r = /* @__PURE__ */ se((n, a) => {
    const { asChild: i, ...o } = n, s = i ? Ke : t;
    return X(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, Qt({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function rh(e, t) {
  e && jl(
    () => e.dispatchEvent(t)
  );
}
function nh(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ah(...e) {
  return (t) => e.forEach(
    (r) => nh(r, t)
  );
}
function ih(...e) {
  return U(ah(...e), e);
}
function lo(e) {
  const t = ee(e);
  return X(() => {
    t.current = e;
  }), W(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
function oh(e, t = globalThis?.document) {
  const r = lo(e);
  X(() => {
    const n = (a) => {
      a.key === "Escape" && r(a);
    };
    return t.addEventListener("keydown", n), () => t.removeEventListener("keydown", n);
  }, [
    r,
    t
  ]);
}
const Yi = "dismissableLayer.update", sh = "dismissableLayer.pointerDownOutside", ch = "dismissableLayer.focusOutside";
let Ko;
const uh = /* @__PURE__ */ Ct({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), lh = /* @__PURE__ */ se((e, t) => {
  var r;
  const { disableOutsidePointerEvents: n = !1, onEscapeKeyDown: a, onPointerDownOutside: i, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...u } = e, h = ao(uh), [l, d] = te(null), f = (r = l?.ownerDocument) !== null && r !== void 0 ? r : globalThis?.document, [, g] = te({}), p = ih(
    t,
    (w) => d(w)
  ), m = Array.from(h.layers), [y] = [
    ...h.layersWithOutsidePointerEventsDisabled
  ].slice(-1), _ = m.indexOf(y), R = l ? m.indexOf(l) : -1, C = h.layersWithOutsidePointerEventsDisabled.size > 0, S = R >= _, P = fh((w) => {
    const x = w.target, E = [
      ...h.branches
    ].some(
      ($) => $.contains(x)
    );
    !S || E || (i?.(w), s?.(w), w.defaultPrevented || c?.());
  }, f), T = dh((w) => {
    const x = w.target;
    [
      ...h.branches
    ].some(
      ($) => $.contains(x)
    ) || (o?.(w), s?.(w), w.defaultPrevented || c?.());
  }, f);
  return oh((w) => {
    R === h.layers.size - 1 && (a?.(w), !w.defaultPrevented && c && (w.preventDefault(), c()));
  }, f), X(() => {
    if (l)
      return n && (h.layersWithOutsidePointerEventsDisabled.size === 0 && (Ko = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), h.layersWithOutsidePointerEventsDisabled.add(l)), h.layers.add(l), Yo(), () => {
        n && h.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = Ko);
      };
  }, [
    l,
    f,
    n,
    h
  ]), X(() => () => {
    l && (h.layers.delete(l), h.layersWithOutsidePointerEventsDisabled.delete(l), Yo());
  }, [
    l,
    h
  ]), X(() => {
    const w = () => g({});
    return document.addEventListener(Yi, w), () => document.removeEventListener(Yi, w);
  }, []), /* @__PURE__ */ V(th.div, Qt({}, u, {
    ref: p,
    style: {
      pointerEvents: C ? S ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: qr(e.onFocusCapture, T.onFocusCapture),
    onBlurCapture: qr(e.onBlurCapture, T.onBlurCapture),
    onPointerDownCapture: qr(e.onPointerDownCapture, P.onPointerDownCapture)
  }));
});
function fh(e, t = globalThis?.document) {
  const r = lo(e), n = ee(!1), a = ee(() => {
  });
  return X(() => {
    const i = (s) => {
      if (s.target && !n.current) {
        let u = function() {
          Dl(sh, r, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = u, t.addEventListener("click", a.current, {
          once: !0
        })) : u();
      } else
        t.removeEventListener("click", a.current);
      n.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [
    t,
    r
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function dh(e, t = globalThis?.document) {
  const r = lo(e), n = ee(!1);
  return X(() => {
    const a = (i) => {
      i.target && !n.current && Dl(ch, r, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [
    t,
    r
  ]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Yo() {
  const e = new CustomEvent(Yi);
  document.dispatchEvent(e);
}
function Dl(e, t, r, { discrete: n }) {
  const a = r.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: r
  });
  t && a.addEventListener(e, t, {
    once: !0
  }), n ? rh(a, i) : a.dispatchEvent(i);
}
let jr = 0;
function hh() {
  X(() => {
    var e, t;
    const r = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = r[0]) !== null && e !== void 0 ? e : Xo()), document.body.insertAdjacentElement("beforeend", (t = r[1]) !== null && t !== void 0 ? t : Xo()), jr++, () => {
      jr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (n) => n.remove()
      ), jr--;
    };
  }, []);
}
function Xo() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
function tr() {
  return tr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tr.apply(this, arguments);
}
function ph(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function vh(...e) {
  return (t) => e.forEach(
    (r) => ph(r, t)
  );
}
function gh(...e) {
  return U(vh(...e), e);
}
const mh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], bh = mh.reduce((e, t) => {
  const r = /* @__PURE__ */ se((n, a) => {
    const { asChild: i, ...o } = n, s = i ? Ke : t;
    return X(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, tr({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function Jo(e) {
  const t = ee(e);
  return X(() => {
    t.current = e;
  }), W(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
const Ir = "focusScope.autoFocusOnMount", Mr = "focusScope.autoFocusOnUnmount", Zo = {
  bubbles: !1,
  cancelable: !0
}, yh = /* @__PURE__ */ se((e, t) => {
  const { loop: r = !1, trapped: n = !1, onMountAutoFocus: a, onUnmountAutoFocus: i, ...o } = e, [s, c] = te(null), u = Jo(a), h = Jo(i), l = ee(null), d = gh(
    t,
    (p) => c(p)
  ), f = ee({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  X(() => {
    if (n) {
      let p = function(R) {
        if (f.paused || !s) return;
        const C = R.target;
        s.contains(C) ? l.current = C : Le(l.current, {
          select: !0
        });
      }, m = function(R) {
        if (f.paused || !s) return;
        const C = R.relatedTarget;
        C !== null && (s.contains(C) || Le(l.current, {
          select: !0
        }));
      }, y = function(R) {
        if (document.activeElement === document.body)
          for (const S of R) S.removedNodes.length > 0 && Le(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", m);
      const _ = new MutationObserver(y);
      return s && _.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", m), _.disconnect();
      };
    }
  }, [
    n,
    s,
    f.paused
  ]), X(() => {
    if (s) {
      es.add(f);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const y = new CustomEvent(Ir, Zo);
        s.addEventListener(Ir, u), s.dispatchEvent(y), y.defaultPrevented || (_h(Sh(Fl(s)), {
          select: !0
        }), document.activeElement === p && Le(s));
      }
      return () => {
        s.removeEventListener(Ir, u), setTimeout(() => {
          const y = new CustomEvent(Mr, Zo);
          s.addEventListener(Mr, h), s.dispatchEvent(y), y.defaultPrevented || Le(p ?? document.body, {
            select: !0
          }), s.removeEventListener(Mr, h), es.remove(f);
        }, 0);
      };
    }
  }, [
    s,
    u,
    h,
    f
  ]);
  const g = U((p) => {
    if (!r && !n || f.paused) return;
    const m = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, y = document.activeElement;
    if (m && y) {
      const _ = p.currentTarget, [R, C] = xh(_);
      R && C ? !p.shiftKey && y === C ? (p.preventDefault(), r && Le(R, {
        select: !0
      })) : p.shiftKey && y === R && (p.preventDefault(), r && Le(C, {
        select: !0
      })) : y === _ && p.preventDefault();
    }
  }, [
    r,
    n,
    f.paused
  ]);
  return /* @__PURE__ */ V(bh.div, tr({
    tabIndex: -1
  }, o, {
    ref: d,
    onKeyDown: g
  }));
});
function _h(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (Le(n, {
      select: t
    }), document.activeElement !== r) return;
}
function xh(e) {
  const t = Fl(e), r = Qo(t, e), n = Qo(t.reverse(), e);
  return [
    r,
    n
  ];
}
function Fl(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Qo(e, t) {
  for (const r of e)
    if (!wh(r, {
      upTo: t
    })) return r;
}
function wh(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Ch(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Le(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== r && Ch(e) && t && e.select();
  }
}
const es = Rh();
function Rh() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && r?.pause(), e = ts(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = ts(e, t), (r = e[0]) === null || r === void 0 || r.resume();
    }
  };
}
function ts(e, t) {
  const r = [
    ...e
  ], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function Sh(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const $h = globalThis?.document ? Pt : () => {
}, Ph = D.useId || (() => {
});
let Eh = 0;
function Oh(e) {
  const [t, r] = D.useState(Ph());
  return $h(() => {
    r(
      (n) => n ?? String(Eh++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function Rt() {
  return Rt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rt.apply(this, arguments);
}
const Ah = ["top", "right", "bottom", "left"], Be = Math.min, me = Math.max, rr = Math.round, kt = Math.floor, Ve = (e) => ({
  x: e,
  y: e
}), Th = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, qh = {
  start: "end",
  end: "start"
};
function Xi(e, t, r) {
  return me(e, Be(t, r));
}
function Ie(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Me(e) {
  return e.split("-")[0];
}
function dt(e) {
  return e.split("-")[1];
}
function fo(e) {
  return e === "x" ? "y" : "x";
}
function ho(e) {
  return e === "y" ? "height" : "width";
}
function ht(e) {
  return ["top", "bottom"].includes(Me(e)) ? "y" : "x";
}
function po(e) {
  return fo(ht(e));
}
function jh(e, t, r) {
  r === void 0 && (r = !1);
  const n = dt(e), a = po(e), i = ho(a);
  let o = a === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = nr(o)), [o, nr(o)];
}
function Ih(e) {
  const t = nr(e);
  return [Ji(e), t, Ji(t)];
}
function Ji(e) {
  return e.replace(/start|end/g, (t) => qh[t]);
}
function Mh(e, t, r) {
  const n = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? a : n : t ? n : a;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function Dh(e, t, r, n) {
  const a = dt(e);
  let i = Mh(Me(e), r === "start", n);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map(Ji)))), i;
}
function nr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Th[t]);
}
function Fh(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Nl(e) {
  return typeof e != "number" ? Fh(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ar(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function rs(e, t, r) {
  let {
    reference: n,
    floating: a
  } = e;
  const i = ht(t), o = po(t), s = ho(o), c = Me(t), u = i === "y", h = n.x + n.width / 2 - a.width / 2, l = n.y + n.height / 2 - a.height / 2, d = n[s] / 2 - a[s] / 2;
  let f;
  switch (c) {
    case "top":
      f = {
        x: h,
        y: n.y - a.height
      };
      break;
    case "bottom":
      f = {
        x: h,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: l
      };
      break;
    case "left":
      f = {
        x: n.x - a.width,
        y: l
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (dt(t)) {
    case "start":
      f[o] -= d * (r && u ? -1 : 1);
      break;
    case "end":
      f[o] += d * (r && u ? -1 : 1);
      break;
  }
  return f;
}
const Nh = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = r, s = i.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: h,
    y: l
  } = rs(u, n, c), d = n, f = {}, g = 0;
  for (let p = 0; p < s.length; p++) {
    const {
      name: m,
      fn: y
    } = s[p], {
      x: _,
      y: R,
      data: C,
      reset: S
    } = await y({
      x: h,
      y: l,
      initialPlacement: n,
      placement: d,
      strategy: a,
      middlewareData: f,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (h = _ ?? h, l = R ?? l, f = {
      ...f,
      [m]: {
        ...f[m],
        ...C
      }
    }, S && g <= 50) {
      g++, typeof S == "object" && (S.placement && (d = S.placement), S.rects && (u = S.rects === !0 ? await o.getElementRects({
        reference: e,
        floating: t,
        strategy: a
      }) : S.rects), {
        x: h,
        y: l
      } = rs(u, d, c)), p = -1;
      continue;
    }
  }
  return {
    x: h,
    y: l,
    placement: d,
    strategy: a,
    middlewareData: f
  };
};
async function St(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: a,
    platform: i,
    rects: o,
    elements: s,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: h = "viewport",
    elementContext: l = "floating",
    altBoundary: d = !1,
    padding: f = 0
  } = Ie(t, e), g = Nl(f), m = s[d ? l === "floating" ? "reference" : "floating" : l], y = ar(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(m))) == null || r ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: h,
    strategy: c
  })), _ = l === "floating" ? {
    ...o.floating,
    x: n,
    y: a
  } : o.reference, R = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), C = await (i.isElement == null ? void 0 : i.isElement(R)) ? await (i.getScale == null ? void 0 : i.getScale(R)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = ar(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: _,
    offsetParent: R,
    strategy: c
  }) : _);
  return {
    top: (y.top - S.top + g.top) / C.y,
    bottom: (S.bottom - y.bottom + g.bottom) / C.y,
    left: (y.left - S.left + g.left) / C.x,
    right: (S.right - y.right + g.right) / C.x
  };
}
const ns = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: a,
      rects: i,
      platform: o,
      elements: s
    } = t, {
      element: c,
      padding: u = 0
    } = Ie(e, t) || {};
    if (c == null)
      return {};
    const h = Nl(u), l = {
      x: r,
      y: n
    }, d = po(a), f = ho(d), g = await o.getDimensions(c), p = d === "y", m = p ? "top" : "left", y = p ? "bottom" : "right", _ = p ? "clientHeight" : "clientWidth", R = i.reference[f] + i.reference[d] - l[d] - i.floating[f], C = l[d] - i.reference[d], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let P = S ? S[_] : 0;
    (!P || !await (o.isElement == null ? void 0 : o.isElement(S))) && (P = s.floating[_] || i.floating[f]);
    const T = R / 2 - C / 2, w = P / 2 - g[f] / 2 - 1, x = Be(h[m], w), E = Be(h[y], w), $ = x, I = P - g[f] - E, A = P / 2 - g[f] / 2 + T, q = Xi($, A, I), M = dt(a) != null && A != q && i.reference[f] / 2 - (A < $ ? x : E) - g[f] / 2 < 0 ? A < $ ? $ - A : I - A : 0;
    return {
      [d]: l[d] - M,
      data: {
        [d]: q,
        centerOffset: A - q + M
      }
    };
  }
}), kh = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r;
      const {
        placement: n,
        middlewareData: a,
        rects: i,
        initialPlacement: o,
        platform: s,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: h = !0,
        fallbackPlacements: l,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: f = "none",
        flipAlignment: g = !0,
        ...p
      } = Ie(e, t), m = Me(n), y = Me(o) === o, _ = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), R = l || (y || !g ? [nr(o)] : Ih(o));
      !l && f !== "none" && R.push(...Dh(o, g, f, _));
      const C = [o, ...R], S = await St(t, p), P = [];
      let T = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (u && P.push(S[m]), h) {
        const $ = jh(n, i, _);
        P.push(S[$[0]], S[$[1]]);
      }
      if (T = [...T, {
        placement: n,
        overflows: P
      }], !P.every(($) => $ <= 0)) {
        var w, x;
        const $ = (((w = a.flip) == null ? void 0 : w.index) || 0) + 1, I = C[$];
        if (I)
          return {
            data: {
              index: $,
              overflows: T
            },
            reset: {
              placement: I
            }
          };
        let A = (x = T.filter((q) => q.overflows[0] <= 0).sort((q, F) => q.overflows[1] - F.overflows[1])[0]) == null ? void 0 : x.placement;
        if (!A)
          switch (d) {
            case "bestFit": {
              var E;
              const q = (E = T.map((F) => [F.placement, F.overflows.filter((M) => M > 0).reduce((M, N) => M + N, 0)]).sort((F, M) => F[1] - M[1])[0]) == null ? void 0 : E[0];
              q && (A = q);
              break;
            }
            case "initialPlacement":
              A = o;
              break;
          }
        if (n !== A)
          return {
            reset: {
              placement: A
            }
          };
      }
      return {};
    }
  };
};
function as(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function is(e) {
  return Ah.some((t) => e[t] >= 0);
}
const Lh = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...a
      } = Ie(e, t);
      switch (n) {
        case "referenceHidden": {
          const i = await St(t, {
            ...a,
            elementContext: "reference"
          }), o = as(i, r.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: is(o)
            }
          };
        }
        case "escaped": {
          const i = await St(t, {
            ...a,
            altBoundary: !0
          }), o = as(i, r.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: is(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Bh(e, t) {
  const {
    placement: r,
    platform: n,
    elements: a
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), o = Me(r), s = dt(r), c = ht(r) === "y", u = ["left", "top"].includes(o) ? -1 : 1, h = i && c ? -1 : 1, l = Ie(t, e);
  let {
    mainAxis: d,
    crossAxis: f,
    alignmentAxis: g
  } = typeof l == "number" ? {
    mainAxis: l,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...l
  };
  return s && typeof g == "number" && (f = s === "end" ? g * -1 : g), c ? {
    x: f * h,
    y: d * u
  } : {
    x: d * u,
    y: f * h
  };
}
const Vh = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n
      } = t, a = await Bh(t, e);
      return {
        x: r + a.x,
        y: n + a.y,
        data: a
      };
    }
  };
}, Hh = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (m) => {
            let {
              x: y,
              y: _
            } = m;
            return {
              x: y,
              y: _
            };
          }
        },
        ...c
      } = Ie(e, t), u = {
        x: r,
        y: n
      }, h = await St(t, c), l = ht(Me(a)), d = fo(l);
      let f = u[d], g = u[l];
      if (i) {
        const m = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", _ = f + h[m], R = f - h[y];
        f = Xi(_, f, R);
      }
      if (o) {
        const m = l === "y" ? "top" : "left", y = l === "y" ? "bottom" : "right", _ = g + h[m], R = g - h[y];
        g = Xi(_, g, R);
      }
      const p = s.fn({
        ...t,
        [d]: f,
        [l]: g
      });
      return {
        ...p,
        data: {
          x: p.x - r,
          y: p.y - n
        }
      };
    }
  };
}, zh = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: a,
        rects: i,
        middlewareData: o
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = Ie(e, t), h = {
        x: r,
        y: n
      }, l = ht(a), d = fo(l);
      let f = h[d], g = h[l];
      const p = Ie(s, t), m = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (c) {
        const R = d === "y" ? "height" : "width", C = i.reference[d] - i.floating[R] + m.mainAxis, S = i.reference[d] + i.reference[R] - m.mainAxis;
        f < C ? f = C : f > S && (f = S);
      }
      if (u) {
        var y, _;
        const R = d === "y" ? "width" : "height", C = ["top", "left"].includes(Me(a)), S = i.reference[l] - i.floating[R] + (C && ((y = o.offset) == null ? void 0 : y[l]) || 0) + (C ? 0 : m.crossAxis), P = i.reference[l] + i.reference[R] + (C ? 0 : ((_ = o.offset) == null ? void 0 : _[l]) || 0) - (C ? m.crossAxis : 0);
        g < S ? g = S : g > P && (g = P);
      }
      return {
        [d]: f,
        [l]: g
      };
    }
  };
}, Uh = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: r,
        rects: n,
        platform: a,
        elements: i
      } = t, {
        apply: o = () => {
        },
        ...s
      } = Ie(e, t), c = await St(t, s), u = Me(r), h = dt(r), l = ht(r) === "y", {
        width: d,
        height: f
      } = n.floating;
      let g, p;
      u === "top" || u === "bottom" ? (g = u, p = h === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (p = u, g = h === "end" ? "top" : "bottom");
      const m = f - c[g], y = d - c[p], _ = !t.middlewareData.shift;
      let R = m, C = y;
      if (l) {
        const P = d - c.left - c.right;
        C = h || _ ? Be(y, P) : P;
      } else {
        const P = f - c.top - c.bottom;
        R = h || _ ? Be(m, P) : P;
      }
      if (_ && !h) {
        const P = me(c.left, 0), T = me(c.right, 0), w = me(c.top, 0), x = me(c.bottom, 0);
        l ? C = d - 2 * (P !== 0 || T !== 0 ? P + T : me(c.left, c.right)) : R = f - 2 * (w !== 0 || x !== 0 ? w + x : me(c.top, c.bottom));
      }
      await o({
        ...t,
        availableWidth: C,
        availableHeight: R
      });
      const S = await a.getDimensions(i.floating);
      return d !== S.width || f !== S.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function He(e) {
  return kl(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function be(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Fe(e) {
  var t;
  return (t = (kl(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function kl(e) {
  return e instanceof Node || e instanceof be(e).Node;
}
function De(e) {
  return e instanceof Element || e instanceof be(e).Element;
}
function Ee(e) {
  return e instanceof HTMLElement || e instanceof be(e).HTMLElement;
}
function os(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof be(e).ShadowRoot;
}
function At(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: a
  } = we(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(a);
}
function Wh(e) {
  return ["table", "td", "th"].includes(He(e));
}
function vo(e) {
  const t = go(), r = we(e);
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function Gh(e) {
  let t = ft(e);
  for (; Ee(t) && !fr(t); ) {
    if (vo(t))
      return t;
    t = ft(t);
  }
  return null;
}
function go() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function fr(e) {
  return ["html", "body", "#document"].includes(He(e));
}
function we(e) {
  return be(e).getComputedStyle(e);
}
function dr(e) {
  return De(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ft(e) {
  if (He(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    os(e) && e.host || // Fallback.
    Fe(e)
  );
  return os(t) ? t.host : t;
}
function Ll(e) {
  const t = ft(e);
  return fr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ee(t) && At(t) ? t : Ll(t);
}
function ir(e, t) {
  var r;
  t === void 0 && (t = []);
  const n = Ll(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = be(n);
  return a ? t.concat(i, i.visualViewport || [], At(n) ? n : []) : t.concat(n, ir(n));
}
function Bl(e) {
  const t = we(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const a = Ee(e), i = a ? e.offsetWidth : r, o = a ? e.offsetHeight : n, s = rr(r) !== i || rr(n) !== o;
  return s && (r = i, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function mo(e) {
  return De(e) ? e : e.contextElement;
}
function lt(e) {
  const t = mo(e);
  if (!Ee(t))
    return Ve(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: a,
    $: i
  } = Bl(t);
  let o = (i ? rr(r.width) : r.width) / n, s = (i ? rr(r.height) : r.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const Kh = /* @__PURE__ */ Ve(0);
function Vl(e) {
  const t = be(e);
  return !go() || !t.visualViewport ? Kh : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Yh(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== be(e) ? !1 : t;
}
function We(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const a = e.getBoundingClientRect(), i = mo(e);
  let o = Ve(1);
  t && (n ? De(n) && (o = lt(n)) : o = lt(e));
  const s = Yh(i, r, n) ? Vl(i) : Ve(0);
  let c = (a.left + s.x) / o.x, u = (a.top + s.y) / o.y, h = a.width / o.x, l = a.height / o.y;
  if (i) {
    const d = be(i), f = n && De(n) ? be(n) : n;
    let g = d.frameElement;
    for (; g && n && f !== d; ) {
      const p = lt(g), m = g.getBoundingClientRect(), y = we(g), _ = m.left + (g.clientLeft + parseFloat(y.paddingLeft)) * p.x, R = m.top + (g.clientTop + parseFloat(y.paddingTop)) * p.y;
      c *= p.x, u *= p.y, h *= p.x, l *= p.y, c += _, u += R, g = be(g).frameElement;
    }
  }
  return ar({
    width: h,
    height: l,
    x: c,
    y: u
  });
}
function Xh(e) {
  let {
    rect: t,
    offsetParent: r,
    strategy: n
  } = e;
  const a = Ee(r), i = Fe(r);
  if (r === i)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = Ve(1);
  const c = Ve(0);
  if ((a || !a && n !== "fixed") && ((He(r) !== "body" || At(i)) && (o = dr(r)), Ee(r))) {
    const u = We(r);
    s = lt(r), c.x = u.x + r.clientLeft, c.y = u.y + r.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - o.scrollLeft * s.x + c.x,
    y: t.y * s.y - o.scrollTop * s.y + c.y
  };
}
function Jh(e) {
  return Array.from(e.getClientRects());
}
function Hl(e) {
  return We(Fe(e)).left + dr(e).scrollLeft;
}
function Zh(e) {
  const t = Fe(e), r = dr(e), n = e.ownerDocument.body, a = me(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = me(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + Hl(e);
  const s = -r.scrollTop;
  return we(n).direction === "rtl" && (o += me(t.clientWidth, n.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: s
  };
}
function Qh(e, t) {
  const r = be(e), n = Fe(e), a = r.visualViewport;
  let i = n.clientWidth, o = n.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, o = a.height;
    const u = go();
    (!u || u && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s,
    y: c
  };
}
function ep(e, t) {
  const r = We(e, !0, t === "fixed"), n = r.top + e.clientTop, a = r.left + e.clientLeft, i = Ee(e) ? lt(e) : Ve(1), o = e.clientWidth * i.x, s = e.clientHeight * i.y, c = a * i.x, u = n * i.y;
  return {
    width: o,
    height: s,
    x: c,
    y: u
  };
}
function ss(e, t, r) {
  let n;
  if (t === "viewport")
    n = Qh(e, r);
  else if (t === "document")
    n = Zh(Fe(e));
  else if (De(t))
    n = ep(t, r);
  else {
    const a = Vl(e);
    n = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return ar(n);
}
function zl(e, t) {
  const r = ft(e);
  return r === t || !De(r) || fr(r) ? !1 : we(r).position === "fixed" || zl(r, t);
}
function tp(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = ir(e).filter((s) => De(s) && He(s) !== "body"), a = null;
  const i = we(e).position === "fixed";
  let o = i ? ft(e) : e;
  for (; De(o) && !fr(o); ) {
    const s = we(o), c = vo(o);
    !c && s.position === "fixed" && (a = null), (i ? !c && !a : !c && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || At(o) && !c && zl(e, o)) ? n = n.filter((h) => h !== o) : a = s, o = ft(o);
  }
  return t.set(e, n), n;
}
function rp(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: a
  } = e;
  const o = [...r === "clippingAncestors" ? tp(t, this._c) : [].concat(r), n], s = o[0], c = o.reduce((u, h) => {
    const l = ss(t, h, a);
    return u.top = me(l.top, u.top), u.right = Be(l.right, u.right), u.bottom = Be(l.bottom, u.bottom), u.left = me(l.left, u.left), u;
  }, ss(t, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function np(e) {
  return Bl(e);
}
function ap(e, t, r) {
  const n = Ee(t), a = Fe(t), i = r === "fixed", o = We(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Ve(0);
  if (n || !n && !i)
    if ((He(t) !== "body" || At(a)) && (s = dr(t)), n) {
      const u = We(t, !0, i, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else a && (c.x = Hl(a));
  return {
    x: o.left + s.scrollLeft - c.x,
    y: o.top + s.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function cs(e, t) {
  return !Ee(e) || we(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Ul(e, t) {
  const r = be(e);
  if (!Ee(e))
    return r;
  let n = cs(e, t);
  for (; n && Wh(n) && we(n).position === "static"; )
    n = cs(n, t);
  return n && (He(n) === "html" || He(n) === "body" && we(n).position === "static" && !vo(n)) ? r : n || Gh(e) || r;
}
const ip = async function(e) {
  let {
    reference: t,
    floating: r,
    strategy: n
  } = e;
  const a = this.getOffsetParent || Ul, i = this.getDimensions;
  return {
    reference: ap(t, await a(r), n),
    floating: {
      x: 0,
      y: 0,
      ...await i(r)
    }
  };
};
function op(e) {
  return we(e).direction === "rtl";
}
const sp = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Xh,
  getDocumentElement: Fe,
  getClippingRect: rp,
  getOffsetParent: Ul,
  getElementRects: ip,
  getClientRects: Jh,
  getDimensions: np,
  getScale: lt,
  isElement: De,
  isRTL: op
};
function cp(e, t) {
  let r = null, n;
  const a = Fe(e);
  function i() {
    clearTimeout(n), r && r.disconnect(), r = null;
  }
  function o(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const {
      left: u,
      top: h,
      width: l,
      height: d
    } = e.getBoundingClientRect();
    if (s || t(), !l || !d)
      return;
    const f = kt(h), g = kt(a.clientWidth - (u + l)), p = kt(a.clientHeight - (h + d)), m = kt(u), _ = {
      rootMargin: -f + "px " + -g + "px " + -p + "px " + -m + "px",
      threshold: me(0, Be(1, c)) || 1
    };
    let R = !0;
    function C(S) {
      const P = S[0].intersectionRatio;
      if (P !== c) {
        if (!R)
          return o();
        P ? o(!1, P) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      R = !1;
    }
    try {
      r = new IntersectionObserver(C, {
        ..._,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(C, _);
    }
    r.observe(e);
  }
  return o(!0), i;
}
function up(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, u = mo(e), h = a || i ? [...u ? ir(u) : [], ...ir(t)] : [];
  h.forEach((y) => {
    a && y.addEventListener("scroll", r, {
      passive: !0
    }), i && y.addEventListener("resize", r);
  });
  const l = u && s ? cp(u, r) : null;
  let d = -1, f = null;
  o && (f = new ResizeObserver((y) => {
    let [_] = y;
    _ && _.target === u && f && (f.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      f && f.observe(t);
    })), r();
  }), u && !c && f.observe(u), f.observe(t));
  let g, p = c ? We(e) : null;
  c && m();
  function m() {
    const y = We(e);
    p && (y.x !== p.x || y.y !== p.y || y.width !== p.width || y.height !== p.height) && r(), p = y, g = requestAnimationFrame(m);
  }
  return r(), () => {
    h.forEach((y) => {
      a && y.removeEventListener("scroll", r), i && y.removeEventListener("resize", r);
    }), l && l(), f && f.disconnect(), f = null, c && cancelAnimationFrame(g);
  };
}
const lp = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), a = {
    platform: sp,
    ...r
  }, i = {
    ...a.platform,
    _c: n
  };
  return Nh(e, t, {
    ...a,
    platform: i
  });
}, fp = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: a
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? ns({
        element: n.current,
        padding: a
      }).fn(r) : {} : n ? ns({
        element: n,
        padding: a
      }).fn(r) : {};
    }
  };
};
var Kt = typeof document < "u" ? Pt : X;
function or(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!or(e[n], t[n]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), r = a.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const i = a[n];
      if (!(i === "_owner" && e.$$typeof) && !or(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Wl(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function us(e, t) {
  const r = Wl(e);
  return Math.round(t * r) / r;
}
function ls(e) {
  const t = D.useRef(e);
  return Kt(() => {
    t.current = e;
  }), t;
}
function dp(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: u
  } = e, [h, l] = D.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [d, f] = D.useState(n);
  or(d, n) || f(n);
  const [g, p] = D.useState(null), [m, y] = D.useState(null), _ = D.useCallback((M) => {
    M != P.current && (P.current = M, p(M));
  }, [p]), R = D.useCallback((M) => {
    M !== T.current && (T.current = M, y(M));
  }, [y]), C = i || g, S = o || m, P = D.useRef(null), T = D.useRef(null), w = D.useRef(h), x = ls(c), E = ls(a), $ = D.useCallback(() => {
    if (!P.current || !T.current)
      return;
    const M = {
      placement: t,
      strategy: r,
      middleware: d
    };
    E.current && (M.platform = E.current), lp(P.current, T.current, M).then((N) => {
      const L = {
        ...N,
        isPositioned: !0
      };
      I.current && !or(w.current, L) && (w.current = L, md.flushSync(() => {
        l(L);
      }));
    });
  }, [d, t, r, E]);
  Kt(() => {
    u === !1 && w.current.isPositioned && (w.current.isPositioned = !1, l((M) => ({
      ...M,
      isPositioned: !1
    })));
  }, [u]);
  const I = D.useRef(!1);
  Kt(() => (I.current = !0, () => {
    I.current = !1;
  }), []), Kt(() => {
    if (C && (P.current = C), S && (T.current = S), C && S) {
      if (x.current)
        return x.current(C, S, $);
      $();
    }
  }, [C, S, $, x]);
  const A = D.useMemo(() => ({
    reference: P,
    floating: T,
    setReference: _,
    setFloating: R
  }), [_, R]), q = D.useMemo(() => ({
    reference: C,
    floating: S
  }), [C, S]), F = D.useMemo(() => {
    const M = {
      position: r,
      left: 0,
      top: 0
    };
    if (!q.floating)
      return M;
    const N = us(q.floating, h.x), L = us(q.floating, h.y);
    return s ? {
      ...M,
      transform: "translate(" + N + "px, " + L + "px)",
      ...Wl(q.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: N,
      top: L
    };
  }, [r, s, q.floating, h.x, h.y]);
  return D.useMemo(() => ({
    ...h,
    update: $,
    refs: A,
    elements: q,
    floatingStyles: F
  }), [h, $, A, q, F]);
}
const hp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Gl = hp.reduce((e, t) => {
  const r = /* @__PURE__ */ se((n, a) => {
    const { asChild: i, ...o } = n, s = i ? Ke : t;
    return X(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, Rt({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function pp(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function vp(...e) {
  return (t) => e.forEach(
    (r) => pp(r, t)
  );
}
function Kl(...e) {
  return U(vp(...e), e);
}
function gp(e, t = []) {
  let r = [];
  function n(i, o) {
    const s = /* @__PURE__ */ Ct(o), c = r.length;
    r = [
      ...r,
      o
    ];
    function u(l) {
      const { scope: d, children: f, ...g } = l, p = d?.[e][c] || s, m = W(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ V(p.Provider, {
        value: m
      }, f);
    }
    function h(l, d) {
      const f = d?.[e][c] || s, g = ao(f);
      if (g) return g;
      if (o !== void 0) return o;
      throw new Error(`\`${l}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [
      u,
      h
    ];
  }
  const a = () => {
    const i = r.map((o) => /* @__PURE__ */ Ct(o));
    return function(s) {
      const c = s?.[e] || i;
      return W(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    n,
    mp(a, ...t)
  ];
}
function mp(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = n.reduce((s, { useScope: c, scopeName: u }) => {
        const l = c(i)[`__scope${u}`];
        return {
          ...s,
          ...l
        };
      }, {});
      return W(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return r.scopeName = t.scopeName, r;
}
function bp(e) {
  const t = ee(e);
  return X(() => {
    t.current = e;
  }), W(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
const Zi = globalThis?.document ? Pt : () => {
};
function yp(e) {
  const [t, r] = te(void 0);
  return Zi(() => {
    if (e) {
      r({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const n = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length) return;
        const i = a[0];
        let o, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          o = u.inlineSize, s = u.blockSize;
        } else
          o = e.offsetWidth, s = e.offsetHeight;
        r({
          width: o,
          height: s
        });
      });
      return n.observe(e, {
        box: "border-box"
      }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [
    e
  ]), t;
}
const Yl = "Popper", [Xl, Jl] = gp(Yl), [_p, Zl] = Xl(Yl), xp = (e) => {
  const { __scopePopper: t, children: r } = e, [n, a] = te(null);
  return /* @__PURE__ */ V(_p, {
    scope: t,
    anchor: n,
    onAnchorChange: a
  }, r);
}, wp = "PopperAnchor", Cp = /* @__PURE__ */ se((e, t) => {
  const { __scopePopper: r, virtualRef: n, ...a } = e, i = Zl(wp, r), o = ee(null), s = Kl(t, o);
  return X(() => {
    i.onAnchorChange(n?.current || o.current);
  }), n ? null : /* @__PURE__ */ V(Gl.div, Rt({}, a, {
    ref: s
  }));
}), Ql = "PopperContent", [Rp, t0] = Xl(Ql), Sp = /* @__PURE__ */ se((e, t) => {
  var r, n, a, i, o, s, c, u;
  const { __scopePopper: h, side: l = "bottom", sideOffset: d = 0, align: f = "center", alignOffset: g = 0, arrowPadding: p = 0, avoidCollisions: m = !0, collisionBoundary: y = [], collisionPadding: _ = 0, sticky: R = "partial", hideWhenDetached: C = !1, updatePositionStrategy: S = "optimized", onPlaced: P, ...T } = e, w = Zl(Ql, h), [x, E] = te(null), $ = Kl(
    t,
    (le) => E(le)
  ), [I, A] = te(null), q = yp(I), F = (r = q?.width) !== null && r !== void 0 ? r : 0, M = (n = q?.height) !== null && n !== void 0 ? n : 0, N = l + (f !== "center" ? "-" + f : ""), L = typeof _ == "number" ? _ : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ..._
  }, G = Array.isArray(y) ? y : [
    y
  ], ne = G.length > 0, ae = {
    padding: L,
    boundary: G.filter($p),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: ne
  }, { refs: ce, floatingStyles: oe, placement: ue, isPositioned: ve, middlewareData: Z } = dp({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: N,
    whileElementsMounted: (...le) => up(...le, {
      animationFrame: S === "always"
    }),
    elements: {
      reference: w.anchor
    },
    middleware: [
      Vh({
        mainAxis: d + M,
        alignmentAxis: g
      }),
      m && Hh({
        mainAxis: !0,
        crossAxis: !1,
        limiter: R === "partial" ? zh() : void 0,
        ...ae
      }),
      m && kh({
        ...ae
      }),
      Uh({
        ...ae,
        apply: ({ elements: le, rects: ke, availableWidth: Mt, availableHeight: Dt }) => {
          const { width: Qe, height: Sr } = ke.reference, et = le.floating.style;
          et.setProperty("--radix-popper-available-width", `${Mt}px`), et.setProperty("--radix-popper-available-height", `${Dt}px`), et.setProperty("--radix-popper-anchor-width", `${Qe}px`), et.setProperty("--radix-popper-anchor-height", `${Sr}px`);
        }
      }),
      I && fp({
        element: I,
        padding: p
      }),
      Pp({
        arrowWidth: F,
        arrowHeight: M
      }),
      C && Lh({
        strategy: "referenceHidden",
        ...ae
      })
    ]
  }), [ge, de] = ef(ue), ie = bp(P);
  Zi(() => {
    ve && ie?.();
  }, [
    ve,
    ie
  ]);
  const _e = (a = Z.arrow) === null || a === void 0 ? void 0 : a.x, Ae = (i = Z.arrow) === null || i === void 0 ? void 0 : i.y, Ne = ((o = Z.arrow) === null || o === void 0 ? void 0 : o.centerOffset) !== 0, [he, Te] = te();
  return Zi(() => {
    x && Te(window.getComputedStyle(x).zIndex);
  }, [
    x
  ]), /* @__PURE__ */ V("div", {
    ref: ce.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...oe,
      transform: ve ? oe.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: he,
      "--radix-popper-transform-origin": [
        (s = Z.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = Z.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ V(Rp, {
    scope: h,
    placedSide: ge,
    onArrowChange: A,
    arrowX: _e,
    arrowY: Ae,
    shouldHideArrow: Ne
  }, /* @__PURE__ */ V(Gl.div, Rt({
    "data-side": ge,
    "data-align": de
  }, T, {
    ref: $,
    style: {
      ...T.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: ve ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (u = Z.hide) !== null && u !== void 0 && u.referenceHidden ? 0 : void 0
    }
  }))));
});
function $p(e) {
  return e !== null;
}
const Pp = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var r, n, a, i, o;
    const { placement: s, rects: c, middlewareData: u } = t, l = ((r = u.arrow) === null || r === void 0 ? void 0 : r.centerOffset) !== 0, d = l ? 0 : e.arrowWidth, f = l ? 0 : e.arrowHeight, [g, p] = ef(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[p], y = ((n = (a = u.arrow) === null || a === void 0 ? void 0 : a.x) !== null && n !== void 0 ? n : 0) + d / 2, _ = ((i = (o = u.arrow) === null || o === void 0 ? void 0 : o.y) !== null && i !== void 0 ? i : 0) + f / 2;
    let R = "", C = "";
    return g === "bottom" ? (R = l ? m : `${y}px`, C = `${-f}px`) : g === "top" ? (R = l ? m : `${y}px`, C = `${c.floating.height + f}px`) : g === "right" ? (R = `${-f}px`, C = l ? m : `${_}px`) : g === "left" && (R = `${c.floating.width + f}px`, C = l ? m : `${_}px`), {
      data: {
        x: R,
        y: C
      }
    };
  }
});
function ef(e) {
  const [t, r = "center"] = e.split("-");
  return [
    t,
    r
  ];
}
const Ep = xp, Op = Cp, Ap = Sp;
function sr() {
  return sr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sr.apply(this, arguments);
}
const Tp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], qp = Tp.reduce((e, t) => {
  const r = /* @__PURE__ */ se((n, a) => {
    const { asChild: i, ...o } = n, s = i ? Ke : t;
    return X(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, sr({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {}), jp = /* @__PURE__ */ se((e, t) => {
  var r;
  const { container: n = globalThis == null || (r = globalThis.document) === null || r === void 0 ? void 0 : r.body, ...a } = e;
  return n ? /* @__PURE__ */ bd.createPortal(/* @__PURE__ */ V(qp.div, sr({}, a, {
    ref: t
  })), n) : null;
}), fs = globalThis?.document ? Pt : () => {
};
function Ip(e, t) {
  return dd((r, n) => {
    const a = t[r][n];
    return a ?? r;
  }, e);
}
const bo = (e) => {
  const { present: t, children: r } = e, n = Mp(t), a = typeof r == "function" ? r({
    present: n.isPresent
  }) : ct.only(r), i = uo(n.ref, a.ref);
  return typeof r == "function" || n.isPresent ? /* @__PURE__ */ lr(a, {
    ref: i
  }) : null;
};
bo.displayName = "Presence";
function Mp(e) {
  const [t, r] = te(), n = ee({}), a = ee(e), i = ee("none"), o = e ? "mounted" : "unmounted", [s, c] = Ip(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return X(() => {
    const u = Lt(n.current);
    i.current = s === "mounted" ? u : "none";
  }, [
    s
  ]), fs(() => {
    const u = n.current, h = a.current;
    if (h !== e) {
      const d = i.current, f = Lt(u);
      e ? c("MOUNT") : f === "none" || u?.display === "none" ? c("UNMOUNT") : c(h && d !== f ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    c
  ]), fs(() => {
    if (t) {
      const u = (l) => {
        const f = Lt(n.current).includes(l.animationName);
        l.target === t && f && jl(
          () => c("ANIMATION_END")
        );
      }, h = (l) => {
        l.target === t && (i.current = Lt(n.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: U((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function Lt(e) {
  return e?.animationName || "none";
}
const Dp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Fp = Dp.reduce((e, t) => {
  const r = /* @__PURE__ */ se((n, a) => {
    const { asChild: i, ...o } = n, s = i ? Ke : t;
    return X(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, Pe({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function tf(e) {
  const t = ee(e);
  return X(() => {
    t.current = e;
  }), W(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
function Np({ prop: e, defaultProp: t, onChange: r = () => {
} }) {
  const [n, a] = kp({
    defaultProp: t,
    onChange: r
  }), i = e !== void 0, o = i ? e : n, s = tf(r), c = U((u) => {
    if (i) {
      const l = typeof u == "function" ? u(e) : u;
      l !== e && s(l);
    } else a(u);
  }, [
    i,
    e,
    a,
    s
  ]);
  return [
    o,
    c
  ];
}
function kp({ defaultProp: e, onChange: t }) {
  const r = te(e), [n] = r, a = ee(n), i = tf(t);
  return X(() => {
    a.current !== n && (i(n), a.current = n);
  }, [
    n,
    a,
    i
  ]), r;
}
var Lp = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, nt = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), Vt = {}, Dr = 0, rf = function(e) {
  return e && (e.host || rf(e.parentNode));
}, Bp = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = rf(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Vp = function(e, t, r, n) {
  var a = Bp(t, Array.isArray(e) ? e : [e]);
  Vt[r] || (Vt[r] = /* @__PURE__ */ new WeakMap());
  var i = Vt[r], o = [], s = /* @__PURE__ */ new Set(), c = new Set(a), u = function(l) {
    !l || s.has(l) || (s.add(l), u(l.parentNode));
  };
  a.forEach(u);
  var h = function(l) {
    !l || c.has(l) || Array.prototype.forEach.call(l.children, function(d) {
      if (s.has(d))
        h(d);
      else {
        var f = d.getAttribute(n), g = f !== null && f !== "false", p = (nt.get(d) || 0) + 1, m = (i.get(d) || 0) + 1;
        nt.set(d, p), i.set(d, m), o.push(d), p === 1 && g && Bt.set(d, !0), m === 1 && d.setAttribute(r, "true"), g || d.setAttribute(n, "true");
      }
    });
  };
  return h(t), s.clear(), Dr++, function() {
    o.forEach(function(l) {
      var d = nt.get(l) - 1, f = i.get(l) - 1;
      nt.set(l, d), i.set(l, f), d || (Bt.has(l) || l.removeAttribute(n), Bt.delete(l)), f || l.removeAttribute(r);
    }), Dr--, Dr || (nt = /* @__PURE__ */ new WeakMap(), nt = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), Vt = {});
  };
}, Hp = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = Lp(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), Vp(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, $e = function() {
  return $e = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, $e.apply(this, arguments);
};
function nf(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function zp(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Yt = "right-scroll-bar-position", Xt = "width-before-scroll-bar", Up = "with-scroll-bars-hidden", Wp = "--removed-body-scroll-bar-size";
function Gp(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Kp(e, t) {
  var r = te(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
function Yp(e, t) {
  return Kp(null, function(r) {
    return e.forEach(function(n) {
      return Gp(n, r);
    });
  });
}
function Xp(e) {
  return e;
}
function Jp(e, t) {
  t === void 0 && (t = Xp);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(i) {
      var o = t(i, n);
      return r.push(o), function() {
        r = r.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; r.length; ) {
        var o = r;
        r = [], o.forEach(i);
      }
      r = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var o = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(i), o = r;
      }
      var c = function() {
        var h = o;
        o = [], h.forEach(i);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), r = {
        push: function(h) {
          o.push(h), u();
        },
        filter: function(h) {
          return o = o.filter(h), r;
        }
      };
    }
  };
  return a;
}
function Zp(e) {
  e === void 0 && (e = {});
  var t = Jp(null);
  return t.options = $e({ async: !0, ssr: !1 }, e), t;
}
var af = function(e) {
  var t = e.sideCar, r = nf(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return D.createElement(n, $e({}, r));
};
af.isSideCarExport = !0;
function Qp(e, t) {
  return e.useMedium(t), af;
}
var of = Zp(), Fr = function() {
}, hr = D.forwardRef(function(e, t) {
  var r = D.useRef(null), n = D.useState({
    onScrollCapture: Fr,
    onWheelCapture: Fr,
    onTouchMoveCapture: Fr
  }), a = n[0], i = n[1], o = e.forwardProps, s = e.children, c = e.className, u = e.removeScrollBar, h = e.enabled, l = e.shards, d = e.sideCar, f = e.noIsolation, g = e.inert, p = e.allowPinchZoom, m = e.as, y = m === void 0 ? "div" : m, _ = nf(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), R = d, C = Yp([r, t]), S = $e($e({}, _), a);
  return D.createElement(
    D.Fragment,
    null,
    h && D.createElement(R, { sideCar: of, removeScrollBar: u, shards: l, noIsolation: f, inert: g, setCallbacks: i, allowPinchZoom: !!p, lockRef: r }),
    o ? D.cloneElement(D.Children.only(s), $e($e({}, S), { ref: C })) : D.createElement(y, $e({}, S, { className: c, ref: C }), s)
  );
});
hr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
hr.classNames = {
  fullWidth: Xt,
  zeroRight: Yt
};
var ev = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function tv() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = ev();
  return t && e.setAttribute("nonce", t), e;
}
function rv(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function nv(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var av = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = tv()) && (rv(t, r), nv(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, iv = function() {
  var e = av();
  return function(t, r) {
    D.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, sf = function() {
  var e = iv(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, ov = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Nr = function(e) {
  return parseInt(e || "", 10) || 0;
}, sv = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Nr(r), Nr(n), Nr(a)];
}, cv = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ov;
  var t = sv(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, uv = sf(), lv = function(e, t, r, n) {
  var a = e.left, i = e.top, o = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(Up, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Yt, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Xt, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Yt, " .").concat(Yt, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Xt, " .").concat(Xt, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body {
    `).concat(Wp, ": ").concat(s, `px;
  }
`);
}, fv = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n, i = D.useMemo(function() {
    return cv(a);
  }, [a]);
  return D.createElement(uv, { styles: lv(i, !t, a, r ? "" : "!important") });
}, Qi = !1;
if (typeof window < "u")
  try {
    var Ht = Object.defineProperty({}, "passive", {
      get: function() {
        return Qi = !0, !0;
      }
    });
    window.addEventListener("test", Ht, Ht), window.removeEventListener("test", Ht, Ht);
  } catch {
    Qi = !1;
  }
var at = Qi ? { passive: !1 } : !1, dv = function(e) {
  return e.tagName === "TEXTAREA";
}, cf = function(e, t) {
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !dv(e) && r[t] === "visible")
  );
}, hv = function(e) {
  return cf(e, "overflowY");
}, pv = function(e) {
  return cf(e, "overflowX");
}, ds = function(e, t) {
  var r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var n = uf(e, r);
    if (n) {
      var a = lf(e, r), i = a[1], o = a[2];
      if (i > o)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== document.body);
  return !1;
}, vv = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, gv = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, uf = function(e, t) {
  return e === "v" ? hv(t) : pv(t);
}, lf = function(e, t) {
  return e === "v" ? vv(t) : gv(t);
}, mv = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, bv = function(e, t, r, n, a) {
  var i = mv(e, window.getComputedStyle(t).direction), o = i * n, s = r.target, c = t.contains(s), u = !1, h = o > 0, l = 0, d = 0;
  do {
    var f = lf(e, s), g = f[0], p = f[1], m = f[2], y = p - m - i * g;
    (g || y) && uf(e, s) && (l += y, d += g), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (h && l === 0 || !h && d === 0) && (u = !0), u;
}, zt = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, hs = function(e) {
  return [e.deltaX, e.deltaY];
}, ps = function(e) {
  return e && "current" in e ? e.current : e;
}, yv = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, _v = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, xv = 0, it = [];
function wv(e) {
  var t = D.useRef([]), r = D.useRef([0, 0]), n = D.useRef(), a = D.useState(xv++)[0], i = D.useState(function() {
    return sf();
  })[0], o = D.useRef(e);
  D.useEffect(function() {
    o.current = e;
  }, [e]), D.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = zp([e.lockRef.current], (e.shards || []).map(ps), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = D.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2)
      return !o.current.allowPinchZoom;
    var y = zt(p), _ = r.current, R = "deltaX" in p ? p.deltaX : _[0] - y[0], C = "deltaY" in p ? p.deltaY : _[1] - y[1], S, P = p.target, T = Math.abs(R) > Math.abs(C) ? "h" : "v";
    if ("touches" in p && T === "h" && P.type === "range")
      return !1;
    var w = ds(T, P);
    if (!w)
      return !0;
    if (w ? S = T : (S = T === "v" ? "h" : "v", w = ds(T, P)), !w)
      return !1;
    if (!n.current && "changedTouches" in p && (R || C) && (n.current = S), !S)
      return !0;
    var x = n.current || S;
    return bv(x, m, p, x === "h" ? R : C);
  }, []), c = D.useCallback(function(p) {
    var m = p;
    if (!(!it.length || it[it.length - 1] !== i)) {
      var y = "deltaY" in m ? hs(m) : zt(m), _ = t.current.filter(function(S) {
        return S.name === m.type && S.target === m.target && yv(S.delta, y);
      })[0];
      if (_ && _.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!_) {
        var R = (o.current.shards || []).map(ps).filter(Boolean).filter(function(S) {
          return S.contains(m.target);
        }), C = R.length > 0 ? s(m, R[0]) : !o.current.noIsolation;
        C && m.cancelable && m.preventDefault();
      }
    }
  }, []), u = D.useCallback(function(p, m, y, _) {
    var R = { name: p, delta: m, target: y, should: _ };
    t.current.push(R), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== R;
      });
    }, 1);
  }, []), h = D.useCallback(function(p) {
    r.current = zt(p), n.current = void 0;
  }, []), l = D.useCallback(function(p) {
    u(p.type, hs(p), p.target, s(p, e.lockRef.current));
  }, []), d = D.useCallback(function(p) {
    u(p.type, zt(p), p.target, s(p, e.lockRef.current));
  }, []);
  D.useEffect(function() {
    return it.push(i), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", c, at), document.addEventListener("touchmove", c, at), document.addEventListener("touchstart", h, at), function() {
      it = it.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", c, at), document.removeEventListener("touchmove", c, at), document.removeEventListener("touchstart", h, at);
    };
  }, []);
  var f = e.removeScrollBar, g = e.inert;
  return D.createElement(
    D.Fragment,
    null,
    g ? D.createElement(i, { styles: _v(a) }) : null,
    f ? D.createElement(fv, { gapMode: "margin" }) : null
  );
}
const Cv = Qp(of, wv);
var ff = D.forwardRef(function(e, t) {
  return D.createElement(hr, $e({}, e, { ref: t, sideCar: Cv }));
});
ff.classNames = hr.classNames;
const df = "Popover", [hf, r0] = Gd(df, [
  Jl
]), yo = Jl(), [Rv, pt] = hf(df), Sv = (e) => {
  const { __scopePopover: t, children: r, open: n, defaultOpen: a, onOpenChange: i, modal: o = !1 } = e, s = yo(t), c = ee(null), [u, h] = te(!1), [l = !1, d] = Np({
    prop: n,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ V(Ep, s, /* @__PURE__ */ V(Rv, {
    scope: t,
    contentId: Oh(),
    triggerRef: c,
    open: l,
    onOpenChange: d,
    onOpenToggle: U(
      () => d(
        (f) => !f
      ),
      [
        d
      ]
    ),
    hasCustomAnchor: u,
    onCustomAnchorAdd: U(
      () => h(!0),
      []
    ),
    onCustomAnchorRemove: U(
      () => h(!1),
      []
    ),
    modal: o
  }, r));
}, $v = "PopoverTrigger", Pv = /* @__PURE__ */ se((e, t) => {
  const { __scopePopover: r, ...n } = e, a = pt($v, r), i = yo(r), o = uo(t, a.triggerRef), s = /* @__PURE__ */ V(Fp.button, Pe({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": a.open,
    "aria-controls": a.contentId,
    "data-state": gf(a.open)
  }, n, {
    ref: o,
    onClick: Gt(e.onClick, a.onOpenToggle)
  }));
  return a.hasCustomAnchor ? s : /* @__PURE__ */ V(Op, Pe({
    asChild: !0
  }, i), s);
}), pf = "PopoverPortal", [Ev, Ov] = hf(pf, {
  forceMount: void 0
}), Av = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: a } = e, i = pt(pf, t);
  return /* @__PURE__ */ V(Ev, {
    scope: t,
    forceMount: r
  }, /* @__PURE__ */ V(bo, {
    present: r || i.open
  }, /* @__PURE__ */ V(jp, {
    asChild: !0,
    container: a
  }, n)));
}, $t = "PopoverContent", Tv = /* @__PURE__ */ se((e, t) => {
  const r = Ov($t, e.__scopePopover), { forceMount: n = r.forceMount, ...a } = e, i = pt($t, e.__scopePopover);
  return /* @__PURE__ */ V(bo, {
    present: n || i.open
  }, i.modal ? /* @__PURE__ */ V(qv, Pe({}, a, {
    ref: t
  })) : /* @__PURE__ */ V(jv, Pe({}, a, {
    ref: t
  })));
}), qv = /* @__PURE__ */ se((e, t) => {
  const r = pt($t, e.__scopePopover), n = ee(null), a = uo(t, n), i = ee(!1);
  return X(() => {
    const o = n.current;
    if (o) return Hp(o);
  }, []), /* @__PURE__ */ V(ff, {
    as: Ke,
    allowPinchZoom: !0
  }, /* @__PURE__ */ V(vf, Pe({}, e, {
    ref: a,
    trapFocus: r.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Gt(e.onCloseAutoFocus, (o) => {
      var s;
      o.preventDefault(), i.current || (s = r.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: Gt(e.onPointerDownOutside, (o) => {
      const s = o.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, u = s.button === 2 || c;
      i.current = u;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: Gt(
      e.onFocusOutside,
      (o) => o.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), jv = /* @__PURE__ */ se((e, t) => {
  const r = pt($t, e.__scopePopover), n = ee(!1), a = ee(!1);
  return /* @__PURE__ */ V(vf, Pe({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var o;
      if ((o = e.onCloseAutoFocus) === null || o === void 0 || o.call(e, i), !i.defaultPrevented) {
        var s;
        n.current || (s = r.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      n.current = !1, a.current = !1;
    },
    onInteractOutside: (i) => {
      var o, s;
      (o = e.onInteractOutside) === null || o === void 0 || o.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
      const c = i.target;
      !((s = r.triggerRef.current) === null || s === void 0) && s.contains(c) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
    }
  }));
}), vf = /* @__PURE__ */ se((e, t) => {
  const { __scopePopover: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: i, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: u, onInteractOutside: h, ...l } = e, d = pt($t, r), f = yo(r);
  return hh(), /* @__PURE__ */ V(yh, {
    asChild: !0,
    loop: !0,
    trapped: n,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ V(lh, {
    asChild: !0,
    disableOutsidePointerEvents: o,
    onInteractOutside: h,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: u,
    onDismiss: () => d.onOpenChange(!1)
  }, /* @__PURE__ */ V(Ap, Pe({
    "data-state": gf(d.open),
    role: "dialog",
    id: d.contentId
  }, f, l, {
    ref: t,
    style: {
      ...l.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function gf(e) {
  return e ? "open" : "closed";
}
const mf = Sv, bf = Pv, yf = Av, _f = Tv, Iv = "_tooltip_5svgn_1", Mv = "_popover_5svgn_5", vs = {
  tooltip: Iv,
  popover: Mv
}, n0 = ({
  actions: e,
  buttonProps: { onClick: t, ...r } = {},
  side: n = "bottom",
  align: a = "end"
}) => {
  const [i, o] = te(!1), s = U(
    (u) => {
      u.stopPropagation(), t?.(u);
    },
    [t]
  );
  if (!e.length) return null;
  const c = (u, h) => {
    switch (u.type) {
      case "button":
      case "link": {
        const l = /* @__PURE__ */ b.jsx(
          Tr.Item,
          {
            icon: u.icon,
            onClick: (d) => {
              u.onClick?.(d), o(!1);
            },
            isDisabled: u.disabled ?? !1,
            children: /* @__PURE__ */ b.jsxs(
              J,
              {
                as: "span",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2px",
                children: [
                  /* @__PURE__ */ b.jsx("span", { children: u.label }),
                  u.description && /* @__PURE__ */ b.jsx(Y.Paragraph, { as: "span", variant: "4", subdued: !0, children: u.description })
                ]
              }
            )
          }
        );
        return /* @__PURE__ */ b.jsx(
          Et,
          {
            className: vs.tooltip,
            content: u.tooltip,
            children: u.type === "link" ? lr(u.link, {
              children: l
            }) : l
          },
          h
        );
      }
      case "divider":
        return /* @__PURE__ */ b.jsx(Tr.Divider, {}, h);
      default:
        return null;
    }
  };
  return /* @__PURE__ */ b.jsxs(mf, { open: i, onOpenChange: o, children: [
    /* @__PURE__ */ b.jsx(bf, { asChild: !0, children: /* @__PURE__ */ b.jsx(
      io,
      {
        variant: "tertiary",
        icon: "dots-v",
        onClick: s,
        ...r
      }
    ) }),
    /* @__PURE__ */ b.jsx(yf, { children: /* @__PURE__ */ b.jsx(
      _f,
      {
        className: vs.popover,
        side: n,
        align: a,
        sideOffset: 8,
        onOpenAutoFocus: (u) => u.preventDefault(),
        children: /* @__PURE__ */ b.jsx(Tr, { children: e.map((u, h) => c(u, h)) })
      }
    ) })
  ] });
};
var mt = {}, eo = function() {
  return (eo = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }).apply(this, arguments);
}, Dv = (function() {
  function e(t, r, n) {
    var a = this;
    this.endVal = r, this.options = n, this.version = "2.6.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: !0, useGrouping: !0, useIndianSeparators: !1, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", enableScrollSpy: !1, scrollSpyDelay: 200, scrollSpyOnce: !1 }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(i) {
      a.startTime || (a.startTime = i);
      var o = i - a.startTime;
      a.remaining = a.duration - o, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(o, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(o, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (o / a.duration);
      var s = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
      a.frameVal = s ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), o < a.duration ? a.rAF = requestAnimationFrame(a.count) : a.finalEndVal !== null ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
    }, this.formatNumber = function(i) {
      var o, s, c, u, h = i < 0 ? "-" : "";
      o = Math.abs(i).toFixed(a.options.decimalPlaces);
      var l = (o += "").split(".");
      if (s = l[0], c = l.length > 1 ? a.options.decimal + l[1] : "", a.options.useGrouping) {
        u = "";
        for (var d = 3, f = 0, g = 0, p = s.length; g < p; ++g) a.options.useIndianSeparators && g === 4 && (d = 2, f = 1), g !== 0 && f % d == 0 && (u = a.options.separator + u), f++, u = s[p - g - 1] + u;
        s = u;
      }
      return a.options.numerals && a.options.numerals.length && (s = s.replace(/[0-9]/g, function(m) {
        return a.options.numerals[+m];
      }), c = c.replace(/[0-9]/g, function(m) {
        return a.options.numerals[+m];
      })), h + a.options.prefix + s + c + a.options.suffix;
    }, this.easeOutExpo = function(i, o, s, c) {
      return s * (1 - Math.pow(2, -10 * i / c)) * 1024 / 1023 + o;
    }, this.options = eo(eo({}, this.defaults), n), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(r), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof t == "string" ? document.getElementById(t) : t, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, t) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
      return a.handleScroll(a);
    }), window.onscroll = function() {
      window.onScrollFns.forEach(function(i) {
        return i();
      });
    }, this.handleScroll(this)));
  }
  return e.prototype.handleScroll = function(t) {
    if (t && window && !t.once) {
      var r = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), a = n.top + window.pageYOffset, i = n.top + n.height + window.pageYOffset;
      i < r && i > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
        return t.start();
      }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > i || a > r) && !t.paused && t.reset();
    }
  }, e.prototype.determineDirectionAndSmartEasing = function() {
    var t = this.finalEndVal ? this.finalEndVal : this.endVal;
    this.countDown = this.startVal > t;
    var r = t - this.startVal;
    if (Math.abs(r) > this.options.smartEasingThreshold && this.options.useEasing) {
      this.finalEndVal = t;
      var n = this.countDown ? 1 : -1;
      this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
    } else this.endVal = t, this.finalEndVal = null;
    this.finalEndVal !== null ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
  }, e.prototype.start = function(t) {
    this.error || (t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
  }, e.prototype.pauseResume = function() {
    this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
  }, e.prototype.reset = function() {
    cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
  }, e.prototype.update = function(t) {
    cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
  }, e.prototype.printValue = function(t) {
    var r;
    if (this.el) {
      var n = this.formattingFn(t);
      (r = this.options.plugin) !== null && r !== void 0 && r.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
    }
  }, e.prototype.ensureNumber = function(t) {
    return typeof t == "number" && !isNaN(t);
  }, e.prototype.validateValue = function(t) {
    var r = Number(t);
    return this.ensureNumber(r) ? r : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
  }, e.prototype.resetDuration = function() {
    this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
  }, e;
})();
const Fv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CountUp: Dv
}, Symbol.toStringTag, { value: "Module" })), Nv = /* @__PURE__ */ Bd(Fv);
var gs;
function kv() {
  if (gs) return mt;
  gs = 1, Object.defineProperty(mt, "__esModule", { value: !0 });
  var e = no, t = Nv;
  function r(w, x) {
    var E = w == null ? null : typeof Symbol < "u" && w[Symbol.iterator] || w["@@iterator"];
    if (E != null) {
      var $, I, A, q, F = [], M = !0, N = !1;
      try {
        if (A = (E = E.call(w)).next, x !== 0) for (; !(M = ($ = A.call(E)).done) && (F.push($.value), F.length !== x); M = !0) ;
      } catch (L) {
        N = !0, I = L;
      } finally {
        try {
          if (!M && E.return != null && (q = E.return(), Object(q) !== q)) return;
        } finally {
          if (N) throw I;
        }
      }
      return F;
    }
  }
  function n(w, x) {
    var E = Object.keys(w);
    if (Object.getOwnPropertySymbols) {
      var $ = Object.getOwnPropertySymbols(w);
      x && ($ = $.filter(function(I) {
        return Object.getOwnPropertyDescriptor(w, I).enumerable;
      })), E.push.apply(E, $);
    }
    return E;
  }
  function a(w) {
    for (var x = 1; x < arguments.length; x++) {
      var E = arguments[x] != null ? arguments[x] : {};
      x % 2 ? n(Object(E), !0).forEach(function($) {
        i(w, $, E[$]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(w, Object.getOwnPropertyDescriptors(E)) : n(Object(E)).forEach(function($) {
        Object.defineProperty(w, $, Object.getOwnPropertyDescriptor(E, $));
      });
    }
    return w;
  }
  function i(w, x, E) {
    return x = p(x), x in w ? Object.defineProperty(w, x, {
      value: E,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : w[x] = E, w;
  }
  function o() {
    return o = Object.assign ? Object.assign.bind() : function(w) {
      for (var x = 1; x < arguments.length; x++) {
        var E = arguments[x];
        for (var $ in E)
          Object.prototype.hasOwnProperty.call(E, $) && (w[$] = E[$]);
      }
      return w;
    }, o.apply(this, arguments);
  }
  function s(w, x) {
    if (w == null) return {};
    var E = {}, $ = Object.keys(w), I, A;
    for (A = 0; A < $.length; A++)
      I = $[A], !(x.indexOf(I) >= 0) && (E[I] = w[I]);
    return E;
  }
  function c(w, x) {
    if (w == null) return {};
    var E = s(w, x), $, I;
    if (Object.getOwnPropertySymbols) {
      var A = Object.getOwnPropertySymbols(w);
      for (I = 0; I < A.length; I++)
        $ = A[I], !(x.indexOf($) >= 0) && Object.prototype.propertyIsEnumerable.call(w, $) && (E[$] = w[$]);
    }
    return E;
  }
  function u(w, x) {
    return h(w) || r(w, x) || l(w, x) || f();
  }
  function h(w) {
    if (Array.isArray(w)) return w;
  }
  function l(w, x) {
    if (w) {
      if (typeof w == "string") return d(w, x);
      var E = Object.prototype.toString.call(w).slice(8, -1);
      if (E === "Object" && w.constructor && (E = w.constructor.name), E === "Map" || E === "Set") return Array.from(w);
      if (E === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(E)) return d(w, x);
    }
  }
  function d(w, x) {
    (x == null || x > w.length) && (x = w.length);
    for (var E = 0, $ = new Array(x); E < x; E++) $[E] = w[E];
    return $;
  }
  function f() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function g(w, x) {
    if (typeof w != "object" || w === null) return w;
    var E = w[Symbol.toPrimitive];
    if (E !== void 0) {
      var $ = E.call(w, x);
      if (typeof $ != "object") return $;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (x === "string" ? String : Number)(w);
  }
  function p(w) {
    var x = g(w, "string");
    return typeof x == "symbol" ? x : String(x);
  }
  var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? e.useLayoutEffect : e.useEffect;
  function y(w) {
    var x = e.useRef(w);
    return m(function() {
      x.current = w;
    }), e.useCallback(function() {
      for (var E = arguments.length, $ = new Array(E), I = 0; I < E; I++)
        $[I] = arguments[I];
      return x.current.apply(void 0, $);
    }, []);
  }
  var _ = function(x, E) {
    var $ = E.decimal, I = E.decimals, A = E.duration, q = E.easingFn, F = E.end, M = E.formattingFn, N = E.numerals, L = E.prefix, G = E.separator, ne = E.start, ae = E.suffix, ce = E.useEasing, oe = E.useGrouping, ue = E.useIndianSeparators, ve = E.enableScrollSpy, Z = E.scrollSpyDelay, ge = E.scrollSpyOnce;
    return new t.CountUp(x, F, {
      startVal: ne,
      duration: A,
      decimal: $,
      decimalPlaces: I,
      easingFn: q,
      formattingFn: M,
      numerals: N,
      separator: G,
      prefix: L,
      suffix: ae,
      useEasing: ce,
      useIndianSeparators: ue,
      useGrouping: oe,
      enableScrollSpy: ve,
      scrollSpyDelay: Z,
      scrollSpyOnce: ge
    });
  }, R = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"], C = {
    decimal: ".",
    separator: ",",
    delay: null,
    prefix: "",
    suffix: "",
    duration: 2,
    start: 0,
    decimals: 0,
    startOnMount: !0,
    enableReinitialize: !0,
    useEasing: !0,
    useGrouping: !0,
    useIndianSeparators: !1
  }, S = function(x) {
    var E = Object.fromEntries(Object.entries(x).filter(function(he) {
      var Te = u(he, 2), le = Te[1];
      return le !== void 0;
    })), $ = e.useMemo(function() {
      return a(a({}, C), E);
    }, [x]), I = $.ref, A = $.startOnMount, q = $.enableReinitialize, F = $.delay, M = $.onEnd, N = $.onStart, L = $.onPauseResume, G = $.onReset, ne = $.onUpdate, ae = c($, R), ce = e.useRef(), oe = e.useRef(), ue = e.useRef(!1), ve = y(function() {
      return _(typeof I == "string" ? I : I.current, ae);
    }), Z = y(function(he) {
      var Te = ce.current;
      if (Te && !he)
        return Te;
      var le = ve();
      return ce.current = le, le;
    }), ge = y(function() {
      var he = function() {
        return Z(!0).start(function() {
          M?.({
            pauseResume: de,
            reset: ie,
            start: Ae,
            update: _e
          });
        });
      };
      F && F > 0 ? oe.current = setTimeout(he, F * 1e3) : he(), N?.({
        pauseResume: de,
        reset: ie,
        update: _e
      });
    }), de = y(function() {
      Z().pauseResume(), L?.({
        reset: ie,
        start: Ae,
        update: _e
      });
    }), ie = y(function() {
      Z().el && (oe.current && clearTimeout(oe.current), Z().reset(), G?.({
        pauseResume: de,
        start: Ae,
        update: _e
      }));
    }), _e = y(function(he) {
      Z().update(he), ne?.({
        pauseResume: de,
        reset: ie,
        start: Ae
      });
    }), Ae = y(function() {
      ie(), ge();
    }), Ne = y(function(he) {
      A && (he && ie(), ge());
    });
    return e.useEffect(function() {
      ue.current ? q && Ne(!0) : (ue.current = !0, Ne());
    }, [q, ue, Ne, F, x.start, x.suffix, x.prefix, x.duration, x.separator, x.decimals, x.decimal, x.formattingFn]), e.useEffect(function() {
      return function() {
        ie();
      };
    }, [ie]), {
      start: Ae,
      pauseResume: de,
      reset: ie,
      update: _e,
      getCountUp: Z
    };
  }, P = ["className", "redraw", "containerProps", "children", "style"], T = function(x) {
    var E = x.className, $ = x.redraw, I = x.containerProps, A = x.children, q = x.style, F = c(x, P), M = e.useRef(null), N = e.useRef(!1), L = S(a(a({}, F), {}, {
      ref: M,
      startOnMount: typeof A != "function" || x.delay === 0,
      // component manually restarts
      enableReinitialize: !1
    })), G = L.start, ne = L.reset, ae = L.update, ce = L.pauseResume, oe = L.getCountUp, ue = y(function() {
      G();
    }), ve = y(function(de) {
      x.preserveValue || ne(), ae(de);
    }), Z = y(function() {
      if (typeof x.children == "function" && !(M.current instanceof Element)) {
        console.error(`Couldn't find attached element to hook the CountUp instance into! Try to attach "containerRef" from the render prop to a an Element, eg. <span ref={containerRef} />.`);
        return;
      }
      oe();
    });
    e.useEffect(function() {
      Z();
    }, [Z]), e.useEffect(function() {
      N.current && ve(x.end);
    }, [x.end, ve]);
    var ge = $ && x;
    return e.useEffect(function() {
      $ && N.current && ue();
    }, [ue, $, ge]), e.useEffect(function() {
      !$ && N.current && ue();
    }, [ue, $, x.start, x.suffix, x.prefix, x.duration, x.separator, x.decimals, x.decimal, x.className, x.formattingFn]), e.useEffect(function() {
      N.current = !0;
    }, []), typeof A == "function" ? A({
      countUpRef: M,
      start: G,
      reset: ne,
      update: ae,
      pauseResume: ce,
      getCountUp: oe
    }) : /* @__PURE__ */ e.createElement("span", o({
      className: E,
      ref: M,
      style: q
    }, I), typeof x.start < "u" ? oe().formattingFn(x.start) : "");
  };
  return mt.default = T, mt.useCountUp = S, mt;
}
var Lv = kv();
const Bv = /* @__PURE__ */ Re(Lv), Vv = "_bar_1n5dj_1", Hv = "_section_1n5dj_5", zv = "_sectionHidden_1n5dj_8", Uv = "_sectionInheritRadius_1n5dj_11", Wv = "_valueOutside_1n5dj_15", ot = {
  bar: Vv,
  section: Hv,
  sectionHidden: zv,
  sectionInheritRadius: Uv,
  valueOutside: Wv
}, Jt = ({
  value: e,
  label: t,
  labelWidth: r,
  theme: n = ["var(--dixa-color-purple-700)", "var(--dixa-color-neutral-200)"],
  showFullBar: a = !1,
  showDifference: i = !1
}) => {
  const o = Math.min(e, 100), [s, c] = te([
    null,
    null
  ]), u = Il(s);
  X(() => {
    c([
      o,
      ...a ? [100 - o] : []
    ]);
  }, [o, a]);
  const h = 1.5, l = W(
    () => s.map((d, f) => {
      const g = o && f === 0 || i, p = d !== null && d < 20, m = je(ot.section, {
        [ot.sectionHidden]: a && d === 0,
        [ot.sectionInheritRadius]: !a
      }), y = je(ot.section, {
        [ot.valueOutside]: p
      });
      return /* @__PURE__ */ b.jsx(
        J,
        {
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "0 100",
          background: n[f],
          color: "neutral.000",
          className: m,
          style: {
            flexBasis: `${d ?? 0}%`,
            transition: `flex-basis ${h}s ease-out`
          },
          children: g && /* @__PURE__ */ b.jsx(
            Y.Paragraph,
            {
              className: y,
              variant: "4",
              color: f === 0 && !p ? "var(--dixa-color-neutral-000)" : "var(--dixa-color-neutral-900)",
              children: /* @__PURE__ */ b.jsx(
                Bv,
                {
                  start: u?.[f] ?? 0,
                  end: d ?? 0,
                  duration: h,
                  delay: 0,
                  suffix: "%",
                  children: ({ countUpRef: _ }) => /* @__PURE__ */ b.jsx("span", { ref: _ })
                }
              )
            }
          )
        },
        f
      );
    }),
    [
      o,
      n,
      i,
      a,
      s,
      u
    ]
  );
  return /* @__PURE__ */ b.jsxs(J, { alignItems: "center", gap: "200", children: [
    t && /* @__PURE__ */ b.jsx(oo, { minWidth: r ? `${r}px` : "auto", children: /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "4", children: t }) }),
    /* @__PURE__ */ b.jsx(J, { flex: "1", className: ot.bar, height: "20px", borderRadius: "50", children: l })
  ] });
};
function Ue(e, t = { compact: !1 }) {
  if (e < 1e3)
    return `${(e / 1e3).toFixed(0)}s`;
  const r = Math.floor(e / 1e3 % 60), n = Math.floor(e / (1e3 * 60) % 60), a = Math.floor(e / (1e3 * 60 * 60) % 24), i = Math.floor(e / (1e3 * 60 * 60 * 24)), o = (c, u) => c > 0 ? `${c}${u}` : "";
  return [
    o(i, "d"),
    o(a, "h"),
    o(n, "m") || (t.compact ? "" : "0m"),
    o(r, "s") || (t.compact ? "" : "0s")
  ].filter(Boolean).join(" ");
}
function cr(e) {
  return /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})?)?$/.test(e) ? ut(e, ut.ISO_8601, !0).isValid() : !1;
}
const ms = 1e6, bs = 1e3;
function xf(e) {
  if (e < bs) return Ge(e);
  const t = e >= ms, r = parseFloat(
    (e / (t ? ms : bs)).toFixed(1)
  ), n = t ? "M" : "K";
  return `${Ge(r)}${n}`;
}
function Ge(e) {
  return e.toLocaleString(navigator.language);
}
const a0 = (e) => ({
  metrics: e.filter(Gv),
  chart: e.find(Kv),
  heatmap: e.find(Yv),
  table: e.find(Xv),
  presence: e.find(Jv),
  insight: e.find(Zv)
}), Gv = (e) => e.type === "metric", Kv = (e) => e.type === "chart" && e.visualization !== "heatmap", Yv = (e) => e.type === "chart" && e.visualization === "heatmap", Xv = (e) => e.type === "table", Jv = (e) => e.type === "presence", Zv = (e) => e.type === "ai_insight", Tt = (e, t) => {
  switch (t) {
    case "duration":
      return Ue(e).split(" ").slice(0, 2).join(" ");
    case "count":
      return xf(e);
    case "number":
      return Ge(e);
    case "percentage":
      return `${Ge(e)}%`;
    case "timer":
      return Ue(e);
    default:
      return "";
  }
}, ur = {
  default: 8,
  rating: 5
}, to = Ml.purple[700], Qv = (e) => /^#|^rgb(a)?\(|^hsl(a)?\(|^var\(/.test(e), eg = (e) => {
  const [t, r] = e.split("-"), n = Number(r);
  return ur[t] ? n >= 1 && n <= ur[t] : !1;
}, wf = (e) => Qv(e) ? e : eg(e) ? `var(--dixa-analytics-color-${e}, ${to})` : to, st = (e, t = "default", r) => {
  if (r)
    return wf(r);
  const n = ur[t] ?? ur.default, a = e % n + 1;
  return `var(--dixa-analytics-color-${t}-${a}, ${to})`;
}, tg = "_container_1t2a7_1", rg = {
  container: tg
}, ng = {
  fontFamily: "var(--dixa-typography-family-default)",
  fontSize: "var(--dixa-typography-size-200)",
  fill: "var(--dixa-typography-color-tertiary)"
}, ag = {
  bar: "chart-bar",
  line: "chart-line",
  area: "chart-area",
  pie: "chart-pie",
  donut: "chart-donut"
}, ig = {
  count: {
    label: "#",
    description: "Absolute short numbers, e.g. 1.2K"
  },
  number: {
    label: "#",
    description: "Absolute numbers, e.g. 1.234"
  },
  percentage: {
    label: "%",
    description: "Relative percentages, e.g. 12.34%"
  },
  duration: {
    label: "s",
    description: "Durations, e.g. 12m 34s"
  }
}, qe = {
  tickCount: 5,
  tickProps: ng,
  visualizationIcons: ag,
  instrumentFormatAssets: ig
}, og = ye(function({
  formats: t,
  onChangeFormat: r
}) {
  return /* @__PURE__ */ b.jsx(so, { variant: "secondary", children: t.map(({ value: n, selected: a }) => /* @__PURE__ */ b.jsx(
    co,
    {
      onClick: a ? void 0 : () => r?.(n),
      active: a,
      title: qe.instrumentFormatAssets[n]?.description,
      children: qe.instrumentFormatAssets[n]?.label
    },
    n
  )) });
}), sg = ye(
  function({
    granularities: t,
    onChangeGranularity: r
  }) {
    return /* @__PURE__ */ b.jsx(so, { variant: "secondary", children: t.map(({ value: n, selected: a }) => /* @__PURE__ */ b.jsx(
      co,
      {
        onClick: a ? void 0 : () => r?.(n),
        active: a,
        children: n
      },
      n
    )) });
  }
), cg = "_root_6kwn9_1", ug = "_rootBounded_6kwn9_7", lg = "_rootFluid_6kwn9_7", kr = {
  root: cg,
  rootBounded: ug,
  rootFluid: lg
}, ro = ({
  bounded: e = !1,
  fluid: t = !1,
  children: r
}) => {
  const n = je(kr.root, {
    [kr.rootBounded]: e,
    [kr.rootFluid]: t
  });
  return /* @__PURE__ */ b.jsx("div", { className: n, children: r });
}, fg = ye(
  function({
    data: t
  }) {
    const [r, n] = te(0);
    return X(() => {
      n(Math.max(0, Date.now() - t));
    }, [t]), yd(() => {
      n(Math.max(0, Date.now() - t));
    }, 1e3), /* @__PURE__ */ b.jsx(b.Fragment, { children: Tt(r, "timer") });
  }
), dg = "_wrapper_1w7q6_1", hg = "_text_1w7q6_6", ys = {
  wrapper: dg,
  text: hg
}, pg = ye(function({
  className: t,
  data: r,
  format: n,
  color: a,
  suffix: i
}) {
  const o = W(() => r === null ? "n.a." : n === "timer" ? /* @__PURE__ */ b.jsx(fg, { data: r }) : Tt(r, n), [r, n]), s = W(() => {
    if (r !== null)
      switch (n) {
        case "duration":
          return Ue(r);
        case "count":
          return Ge(r);
        default:
          return;
      }
  }, [r, n]), u = !(r !== null && s !== o) || ["number", "percentage", "timer"].includes(n);
  return /* @__PURE__ */ b.jsx(
    Et,
    {
      content: s,
      disabled: u,
      wrap: "div",
      wrapProps: { className: ys.wrapper },
      children: /* @__PURE__ */ b.jsxs(
        Y.Heading,
        {
          variant: "heading-1",
          color: a ?? (r === null ? "tertiary" : void 0),
          className: je(ys.text, t),
          as: "span",
          children: [
            o,
            i
          ]
        }
      )
    }
  );
}), vg = "_colorIndicator_luubh_1", gg = {
  colorIndicator: vg
}, Cf = ye(function({
  instrument: t,
  theme: r = "light"
}) {
  const { data: n, format: a, title: i, description: o, color: s } = t, c = s ? wf(s) : void 0, u = r === "dark" ? "inherit" : void 0;
  return /* @__PURE__ */ b.jsxs(J, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ b.jsxs(J, { alignItems: "center", gap: "100", title: i, children: [
      s && /* @__PURE__ */ b.jsx(
        oo,
        {
          as: "span",
          className: gg.colorIndicator,
          background: c
        }
      ),
      /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "4", color: u, subdued: !0, children: i })
    ] }),
    /* @__PURE__ */ b.jsx(pg, { data: n, format: a, color: u }),
    o && /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "4", color: u, subdued: !0, children: o })
  ] });
}), mg = ({ categories: e, series: t }, { omitZero: r }) => e.map((n, a) => {
  const i = t.reduce(
    (o, { label: s, data: c }) => {
      const { value: u } = pr(c[a]);
      return (r ? !u : u === null) ? o : { ...o, [s]: u };
    },
    {}
  );
  return {
    name: n.label,
    ...i
  };
}), pr = (e) => e === null || typeof e == "number" ? { value: e } : {
  value: e?.value ?? null,
  metrics: e?.metrics
}, vr = (e) => e?.find(({ selected: t }) => t)?.value ?? "number";
var Lr, _s;
function Rf() {
  if (_s) return Lr;
  _s = 1;
  var e = typeof Ft == "object" && Ft && Ft.Object === Object && Ft;
  return Lr = e, Lr;
}
var Br, xs;
function Oe() {
  if (xs) return Br;
  xs = 1;
  var e = Rf(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return Br = r, Br;
}
var Vr, ws;
function qt() {
  if (ws) return Vr;
  ws = 1;
  var e = Oe(), t = e.Symbol;
  return Vr = t, Vr;
}
var Hr, Cs;
function Sf() {
  if (Cs) return Hr;
  Cs = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = Array(a); ++n < a; )
      i[n] = r(t[n], n, t);
    return i;
  }
  return Hr = e, Hr;
}
var zr, Rs;
function Se() {
  if (Rs) return zr;
  Rs = 1;
  var e = Array.isArray;
  return zr = e, zr;
}
var Ur, Ss;
function bg() {
  if (Ss) return Ur;
  Ss = 1;
  var e = qt(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function i(o) {
    var s = r.call(o, a), c = o[a];
    try {
      o[a] = void 0;
      var u = !0;
    } catch {
    }
    var h = n.call(o);
    return u && (s ? o[a] = c : delete o[a]), h;
  }
  return Ur = i, Ur;
}
var Wr, $s;
function yg() {
  if ($s) return Wr;
  $s = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return Wr = r, Wr;
}
var Gr, Ps;
function Ye() {
  if (Ps) return Gr;
  Ps = 1;
  var e = qt(), t = bg(), r = yg(), n = "[object Null]", a = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function o(s) {
    return s == null ? s === void 0 ? a : n : i && i in Object(s) ? t(s) : r(s);
  }
  return Gr = o, Gr;
}
var Kr, Es;
function Xe() {
  if (Es) return Kr;
  Es = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Kr = e, Kr;
}
var Yr, Os;
function jt() {
  if (Os) return Yr;
  Os = 1;
  var e = Ye(), t = Xe(), r = "[object Symbol]";
  function n(a) {
    return typeof a == "symbol" || t(a) && e(a) == r;
  }
  return Yr = n, Yr;
}
var Xr, As;
function $f() {
  if (As) return Xr;
  As = 1;
  var e = qt(), t = Sf(), r = Se(), n = jt(), a = e ? e.prototype : void 0, i = a ? a.toString : void 0;
  function o(s) {
    if (typeof s == "string")
      return s;
    if (r(s))
      return t(s, o) + "";
    if (n(s))
      return i ? i.call(s) : "";
    var c = s + "";
    return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
  }
  return Xr = o, Xr;
}
var Jr, Ts;
function _g() {
  if (Ts) return Jr;
  Ts = 1;
  function e(t, r, n) {
    var a = -1, i = t.length;
    r < 0 && (r = -r > i ? 0 : i + r), n = n > i ? i : n, n < 0 && (n += i), i = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var o = Array(i); ++a < i; )
      o[a] = t[a + r];
    return o;
  }
  return Jr = e, Jr;
}
var Zr, qs;
function Pf() {
  if (qs) return Zr;
  qs = 1;
  var e = _g();
  function t(r, n, a) {
    var i = r.length;
    return a = a === void 0 ? i : a, !n && a >= i ? r : e(r, n, a);
  }
  return Zr = t, Zr;
}
var Qr, js;
function gr() {
  if (js) return Qr;
  js = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "\\u200d", s = RegExp("[" + o + e + a + i + "]");
  function c(u) {
    return s.test(u);
  }
  return Qr = c, Qr;
}
var en, Is;
function Je() {
  if (Is) return en;
  Is = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return en = e, en;
}
var tn, Ms;
function xg() {
  if (Ms) return tn;
  Ms = 1;
  var e = Ye(), t = Xe(), r = "[object RegExp]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return tn = n, tn;
}
var rn, Ds;
function _o() {
  if (Ds) return rn;
  Ds = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return rn = e, rn;
}
var xt = { exports: {} };
xt.exports;
var Fs;
function Ef() {
  return Fs || (Fs = 1, (function(e, t) {
    var r = Rf(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = (function() {
      try {
        var c = a && a.require && a.require("util").types;
        return c || o && o.binding && o.binding("util");
      } catch {
      }
    })();
    e.exports = s;
  })(xt, xt.exports)), xt.exports;
}
var nn, Ns;
function wg() {
  if (Ns) return nn;
  Ns = 1;
  var e = xg(), t = _o(), r = Ef(), n = r && r.isRegExp, a = n ? t(n) : e;
  return nn = a, nn;
}
var an, ks;
function Of() {
  if (ks) return an;
  ks = 1;
  function e(t) {
    return function(r) {
      return r?.[t];
    };
  }
  return an = e, an;
}
var on, Ls;
function Cg() {
  if (Ls) return on;
  Ls = 1;
  var e = Of(), t = e("length");
  return on = t, on;
}
var sn, Bs;
function Rg() {
  if (Bs) return sn;
  Bs = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + a + "]", c = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + c + ")", h = "[^" + e + "]", l = "(?:\\ud83c[\\udde6-\\uddff]){2}", d = "[\\ud800-\\udbff][\\udc00-\\udfff]", f = "\\u200d", g = u + "?", p = "[" + i + "]?", m = "(?:" + f + "(?:" + [h, l, d].join("|") + ")" + p + g + ")*", y = p + g + m, _ = "(?:" + [h + s + "?", s, l, d, o].join("|") + ")", R = RegExp(c + "(?=" + c + ")|" + _ + y, "g");
  function C(S) {
    for (var P = R.lastIndex = 0; R.test(S); )
      ++P;
    return P;
  }
  return sn = C, sn;
}
var cn, Vs;
function Sg() {
  if (Vs) return cn;
  Vs = 1;
  var e = Cg(), t = gr(), r = Rg();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return cn = n, cn;
}
var un, Hs;
function $g() {
  if (Hs) return un;
  Hs = 1;
  function e(t) {
    return t.split("");
  }
  return un = e, un;
}
var ln, zs;
function Pg() {
  if (zs) return ln;
  zs = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + a + "]", c = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + c + ")", h = "[^" + e + "]", l = "(?:\\ud83c[\\udde6-\\uddff]){2}", d = "[\\ud800-\\udbff][\\udc00-\\udfff]", f = "\\u200d", g = u + "?", p = "[" + i + "]?", m = "(?:" + f + "(?:" + [h, l, d].join("|") + ")" + p + g + ")*", y = p + g + m, _ = "(?:" + [h + s + "?", s, l, d, o].join("|") + ")", R = RegExp(c + "(?=" + c + ")|" + _ + y, "g");
  function C(S) {
    return S.match(R) || [];
  }
  return ln = C, ln;
}
var fn, Us;
function Af() {
  if (Us) return fn;
  Us = 1;
  var e = $g(), t = gr(), r = Pg();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return fn = n, fn;
}
var dn, Ws;
function Eg() {
  if (Ws) return dn;
  Ws = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return dn = t, dn;
}
var hn, Gs;
function Og() {
  if (Gs) return hn;
  Gs = 1;
  var e = Eg(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return hn = r, hn;
}
var pn, Ks;
function Tf() {
  if (Ks) return pn;
  Ks = 1;
  var e = Og(), t = Je(), r = jt(), n = NaN, a = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt;
  function c(u) {
    if (typeof u == "number")
      return u;
    if (r(u))
      return n;
    if (t(u)) {
      var h = typeof u.valueOf == "function" ? u.valueOf() : u;
      u = t(h) ? h + "" : h;
    }
    if (typeof u != "string")
      return u === 0 ? u : +u;
    u = e(u);
    var l = i.test(u);
    return l || o.test(u) ? s(u.slice(2), l ? 2 : 8) : a.test(u) ? n : +u;
  }
  return pn = c, pn;
}
var vn, Ys;
function Ag() {
  if (Ys) return vn;
  Ys = 1;
  var e = Tf(), t = 1 / 0, r = 17976931348623157e292;
  function n(a) {
    if (!a)
      return a === 0 ? a : 0;
    if (a = e(a), a === t || a === -t) {
      var i = a < 0 ? -1 : 1;
      return i * r;
    }
    return a === a ? a : 0;
  }
  return vn = n, vn;
}
var gn, Xs;
function Tg() {
  if (Xs) return gn;
  Xs = 1;
  var e = Ag();
  function t(r) {
    var n = e(r), a = n % 1;
    return n === n ? a ? n - a : n : 0;
  }
  return gn = t, gn;
}
var mn, Js;
function mr() {
  if (Js) return mn;
  Js = 1;
  var e = $f();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return mn = t, mn;
}
var bn, Zs;
function qg() {
  if (Zs) return bn;
  Zs = 1;
  var e = $f(), t = Pf(), r = gr(), n = Je(), a = wg(), i = Sg(), o = Af(), s = Tg(), c = mr(), u = 30, h = "...", l = /\w*$/;
  function d(f, g) {
    var p = u, m = h;
    if (n(g)) {
      var y = "separator" in g ? g.separator : y;
      p = "length" in g ? s(g.length) : p, m = "omission" in g ? e(g.omission) : m;
    }
    f = c(f);
    var _ = f.length;
    if (r(f)) {
      var R = o(f);
      _ = R.length;
    }
    if (p >= _)
      return f;
    var C = p - i(m);
    if (C < 1)
      return m;
    var S = R ? t(R, 0, C).join("") : f.slice(0, C);
    if (y === void 0)
      return S + m;
    if (R && (C += S.length - C), a(y)) {
      if (f.slice(C).search(y)) {
        var P, T = S;
        for (y.global || (y = RegExp(y.source, c(l.exec(y)) + "g")), y.lastIndex = 0; P = y.exec(T); )
          var w = P.index;
        S = S.slice(0, w === void 0 ? C : w);
      }
    } else if (f.indexOf(e(y), C) != C) {
      var x = S.lastIndexOf(y);
      x > -1 && (S = S.slice(0, x));
    }
    return S + m;
  }
  return bn = d, bn;
}
var jg = qg();
const Ig = /* @__PURE__ */ Re(jg), qf = (e, t = "D", {
  long: r = !1,
  timezone: n = ut.tz.guess()
} = {}) => {
  const a = ut.tz(e, n), i = ut.locale() === "en", o = (s) => r ? s.format("ddd, ll") : s.format(i ? "MMM DD" : "DD MMM");
  switch (t) {
    case "H":
      return a.format("LT");
    case "W":
      return r ? `${o(a)} - ${o(
        a.endOf("week")
      )} (W${a.format("W")})` : o(a);
    case "M":
      return a.format(r ? "MMM YYYY" : "MMM");
    default:
      return o(a);
  }
}, jf = (e, t = {}) => t?.length ? Ig(e, t) : e, Mg = "_root_on75o_54", Dg = {
  root: Mg
}, Fg = ye(function({
  instrument: t,
  granularity: r,
  timezone: n,
  tooltipProps: a
}) {
  const { active: i, payload: o, label: s } = a, { categories: c, series: u } = t.data, h = c.find((R) => R.label === s), l = h?.metrics ?? [], d = 24, f = Math.max(0, (o?.length ?? 0) - d), g = vr(t.data.formats), p = W(() => u.length === 1 && ["count", "number"].includes(g) && !c.every(({ label: C }) => cr(C)) ? u[0].data.reduce((C, S) => {
    const { value: P } = pr(S);
    return typeof P == "number" ? C + P : C;
  }, 0) : null, [c, g, u]), m = W(
    () => o?.slice(
      0,
      // When there are more series than the limit, subtract one to make room for the overflow indicator.
      f > 0 ? d - 1 : d
    ).map((R) => {
      const C = R.value ?? 0, S = C && p ? C / p * 100 : null, P = S ? `${S.toFixed(2)}%` : void 0;
      return {
        type: "metric",
        title: R.name ?? "",
        color: R.color,
        data: C,
        format: g,
        description: P
      };
    }),
    [o, d, f, p, g]
  ), y = U(
    (R) => R?.map((C) => /* @__PURE__ */ b.jsx(
      Cf,
      {
        instrument: C,
        theme: "dark"
      },
      C.title
    )),
    []
  ), _ = W(
    () => h?.label ? cr(h.label) ? qf(h.label, r, {
      timezone: n,
      long: !0
    }) : jf(h.label) : null,
    [h?.label, r, n]
  );
  return !i || !o ? null : /* @__PURE__ */ b.jsxs("div", { className: Dg.root, children: [
    _ && /* @__PURE__ */ b.jsxs(J, { flexDirection: "column", gap: "100", children: [
      /* @__PURE__ */ b.jsx(Y.Heading, { variant: "heading-2", color: "inherit", children: _ }),
      h?.description && /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "4", color: "inherit", children: h.description })
    ] }),
    l.length > 0 && /* @__PURE__ */ b.jsx(ro, { bounded: !0, children: y(l) }),
    /* @__PURE__ */ b.jsxs(ro, { bounded: !0, children: [
      y(m),
      f > 0 && /* @__PURE__ */ b.jsx(J, { flex: "1", alignItems: "center", children: /* @__PURE__ */ b.jsxs(Y.Heading, { variant: "heading-2", color: "inherit", children: [
        "+ ",
        f + 1,
        " more"
      ] }) })
    ] })
  ] });
});
var yn, Qs;
function Ng() {
  if (Qs) return yn;
  Qs = 1;
  var e = Pf(), t = gr(), r = Af(), n = mr();
  function a(i) {
    return function(o) {
      o = n(o);
      var s = t(o) ? r(o) : void 0, c = s ? s[0] : o.charAt(0), u = s ? e(s, 1).join("") : o.slice(1);
      return c[i]() + u;
    };
  }
  return yn = a, yn;
}
var _n, ec;
function kg() {
  if (ec) return _n;
  ec = 1;
  var e = Ng(), t = e("toUpperCase");
  return _n = t, _n;
}
var xn, tc;
function Lg() {
  if (tc) return xn;
  tc = 1;
  var e = mr(), t = kg();
  function r(n) {
    return t(e(n).toLowerCase());
  }
  return xn = r, xn;
}
var Bg = Lg();
const Vg = /* @__PURE__ */ Re(Bg), Hg = ye(
  function({
    visualization: t,
    visualizations: r,
    onChangeVisualization: n
  }) {
    return r.length <= 1 ? null : /* @__PURE__ */ b.jsx(so, { variant: "secondary", children: r.map((a) => /* @__PURE__ */ b.jsx(
      io,
      {
        icon: qe.visualizationIcons[a],
        onClick: () => {
          n(a);
        },
        active: t === a,
        title: `${Vg(a)} chart`
      },
      a
    )) });
  }
), zg = ({
  instrument: e,
  granularity: t,
  timezone: r,
  syncOptions: n
}) => {
  const { data: a, layout: i } = e, o = i === "horizontal", s = i === "vertical", c = 192, u = W(() => {
    if (s) return 0;
    const g = a.categories.length % 2 === 0;
    switch (t) {
      // There are always an even number of categories, so we preserve the first tick in order to
      // ensure that hours are shown in even intervals e.g. 08:00, 10:00, 12:00 ... 22:00.
      case "H":
        return "preserveStart";
      // When the number of days is even, we preserve the last tick in order to ensure that
      // days are shown in equal intervals e.g. Apr 2, Apr 4, Apr 6 ... Apr 30. When uneven, we
      // preserve the first tick, resulting in equal intervals e.g. Mar 1, Mar 4, Mar 7 ... Mar 31.
      case "D":
      case "W":
        return g ? "preserveEnd" : "preserveStart";
      default:
        return "preserveStartEnd";
    }
  }, [a.categories.length, t, s]), h = {
    dataKey: "name",
    width: s ? c : 0,
    tickLine: {
      stroke: "var(--dixa-color-neutral-200)"
    },
    axisLine: {
      stroke: "var(--dixa-color-neutral-200)"
    },
    tickSize: 6,
    tickMargin: 8,
    interval: u,
    tick: qe.tickProps,
    tickFormatter: (g) => cr(g) ? qf(g, t, { timezone: r }) : jf(g, { length: c / 10 })
  }, l = {
    domain: [0, "auto"],
    allowDecimals: !1,
    tickLine: !1,
    axisLine: !1,
    tick: qe.tickProps,
    ticks: n?.ticks,
    tickCount: qe.tickCount,
    tickFormatter: (g) => Tt(g, vr(a.formats))
  }, d = o ? { type: "category", ...h } : { type: "number", ...l }, f = o ? { type: "number", ...l } : { type: "category", ...h };
  return { xAxisProps: d, yAxisProps: f };
};
var wn, rc;
function Ug() {
  if (rc) return wn;
  rc = 1;
  var e = Oe(), t = function() {
    return e.Date.now();
  };
  return wn = t, wn;
}
var Cn, nc;
function Wg() {
  if (nc) return Cn;
  nc = 1;
  var e = Je(), t = Ug(), r = Tf(), n = "Expected a function", a = Math.max, i = Math.min;
  function o(s, c, u) {
    var h, l, d, f, g, p, m = 0, y = !1, _ = !1, R = !0;
    if (typeof s != "function")
      throw new TypeError(n);
    c = r(c) || 0, e(u) && (y = !!u.leading, _ = "maxWait" in u, d = _ ? a(r(u.maxWait) || 0, c) : d, R = "trailing" in u ? !!u.trailing : R);
    function C(A) {
      var q = h, F = l;
      return h = l = void 0, m = A, f = s.apply(F, q), f;
    }
    function S(A) {
      return m = A, g = setTimeout(w, c), y ? C(A) : f;
    }
    function P(A) {
      var q = A - p, F = A - m, M = c - q;
      return _ ? i(M, d - F) : M;
    }
    function T(A) {
      var q = A - p, F = A - m;
      return p === void 0 || q >= c || q < 0 || _ && F >= d;
    }
    function w() {
      var A = t();
      if (T(A))
        return x(A);
      g = setTimeout(w, P(A));
    }
    function x(A) {
      return g = void 0, R && h ? C(A) : (h = l = void 0, f);
    }
    function E() {
      g !== void 0 && clearTimeout(g), m = 0, h = p = l = g = void 0;
    }
    function $() {
      return g === void 0 ? f : x(t());
    }
    function I() {
      var A = t(), q = T(A);
      if (h = arguments, l = this, p = A, q) {
        if (g === void 0)
          return S(p);
        if (_)
          return clearTimeout(g), g = setTimeout(w, c), C(p);
      }
      return g === void 0 && (g = setTimeout(w, c)), f;
    }
    return I.cancel = E, I.flush = $, I;
  }
  return Cn = o, Cn;
}
var Gg = Wg();
const Kg = /* @__PURE__ */ Re(Gg), Yg = "_legendItem_15b15_54", Xg = "_legendItemInactive_15b15_61", Jg = "_legendIcon_15b15_65", Zg = "_legendIconBar_15b15_72", Qg = "_legendIconLine_15b15_75", bt = {
  legendItem: Yg,
  legendItemInactive: Xg,
  legendIcon: Jg,
  legendIconBar: Zg,
  legendIconLine: Qg
}, em = ye(function({
  instrument: t,
  legend: r,
  visualization: n,
  onToggleLegendItem: a,
  onMouseEnterLegendItem: i,
  onMouseLeaveLegendItem: o,
  hoveredLegend: s
}) {
  const { series: c, options: u } = t.data, { layout: h } = u?.legend ?? {
    layout: "horizontal"
  }, l = h === "horizontal";
  return /* @__PURE__ */ b.jsx(
    J,
    {
      padding: l ? "0" : "0 0 0 400",
      flexDirection: l ? "row" : "column",
      gap: l ? "400" : "200",
      justifyContent: "center",
      children: c.map(({ label: d, options: f }, g) => {
        const p = st(
          g,
          void 0,
          f?.color
        ), m = je(bt.legendItem, {
          [bt.legendItemInactive]: s && s !== d
        }), y = je(bt.legendIcon, {
          [bt.legendIconBar]: n !== "line",
          [bt.legendIconLine]: n === "line"
        });
        return /* @__PURE__ */ b.jsxs(
          J,
          {
            gap: "200",
            flexDirection: "row",
            alignItems: "center",
            className: m,
            onClick: () => a(d),
            onMouseEnter: () => i?.(d),
            onMouseLeave: () => o?.(d),
            children: [
              /* @__PURE__ */ b.jsx(
                "span",
                {
                  className: y,
                  style: {
                    borderColor: p,
                    backgroundColor: r.includes(d) ? p : "transparent"
                  }
                }
              ),
              /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "4", subdued: !0, children: d })
            ]
          },
          d
        );
      })
    }
  );
}), tm = ({
  instrument: e,
  visualization: t
}) => {
  const {
    data: { series: r, options: n }
  } = e, a = n?.legend?.layout === "horizontal", [i, o] = _d(
    r.filter(({ options: m }) => m?.visible ?? !0).map(({ label: m }) => m)
  ), [s, c] = te(null);
  Ot(() => {
    u();
  }, [r.length]);
  const u = U(() => {
    o.set(r.map(({ label: m }) => m));
  }, [r, o]), h = U(
    (m) => {
      i.includes(m) && c(m);
    },
    [i]
  ), l = W(
    () => Kg(h, 300),
    [h]
  ), d = U(() => {
    l.cancel(), c(null);
  }, [l]), f = U(
    (m) => {
      i.length === r.length ? o.filter((y) => y === m) : i.length === 1 && i.includes(m) ? u() : i.includes(m) ? o.removeAt(i.indexOf(m)) : o.push(m);
    },
    [r.length, u, i, o]
  ), g = W(
    () => r.length < 10 ? {
      onMouseEnterLegendItem: l,
      onMouseLeaveLegendItem: d,
      hoveredLegend: s
    } : {},
    [
      l,
      d,
      s,
      r.length
    ]
  ), p = W(
    () => ({
      layout: n?.legend?.layout,
      align: a ? "center" : "right",
      verticalAlign: a ? "bottom" : "middle",
      wrapperStyle: {
        overflow: "auto",
        ...a ? {
          bottom: 0
        } : {
          right: 0,
          width: 208,
          maxHeight: "100%"
        }
      },
      // Using the render function form instead of directly passing an element prevents the
      // `ChartInstrumentLegend` component from re-rendering unnecessarily due to Recharts props
      // changing, because Recharts automatically passes props to the `content` element.
      content: () => /* @__PURE__ */ b.jsx(
        em,
        {
          visualization: t,
          instrument: e,
          legend: i,
          onToggleLegendItem: f,
          ...g
        }
      )
    }),
    [
      f,
      e,
      a,
      i,
      g,
      n?.legend?.layout,
      t
    ]
  );
  return {
    legend: i,
    legendProps: p,
    hoveredLegend: s
  };
};
var Rn, ac;
function rm() {
  if (ac) return Rn;
  ac = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return Rn = e, Rn;
}
var nm = rm();
const am = /* @__PURE__ */ Re(nm);
var Sn, ic;
function xo() {
  if (ic) return Sn;
  ic = 1;
  var e = Se(), t = jt(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function a(i, o) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : n.test(i) || !r.test(i) || o != null && i in Object(o);
  }
  return Sn = a, Sn;
}
var $n, oc;
function If() {
  if (oc) return $n;
  oc = 1;
  var e = Ye(), t = Je(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", i = "[object Proxy]";
  function o(s) {
    if (!t(s))
      return !1;
    var c = e(s);
    return c == n || c == a || c == r || c == i;
  }
  return $n = o, $n;
}
var Pn, sc;
function im() {
  if (sc) return Pn;
  sc = 1;
  var e = Oe(), t = e["__core-js_shared__"];
  return Pn = t, Pn;
}
var En, cc;
function om() {
  if (cc) return En;
  cc = 1;
  var e = im(), t = (function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!t && t in n;
  }
  return En = r, En;
}
var On, uc;
function Mf() {
  if (uc) return On;
  uc = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return On = r, On;
}
var An, lc;
function sm() {
  if (lc) return An;
  lc = 1;
  var e = If(), t = om(), r = Je(), n = Mf(), a = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, o = Function.prototype, s = Object.prototype, c = o.toString, u = s.hasOwnProperty, h = RegExp(
    "^" + c.call(u).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function l(d) {
    if (!r(d) || t(d))
      return !1;
    var f = e(d) ? h : i;
    return f.test(n(d));
  }
  return An = l, An;
}
var Tn, fc;
function cm() {
  if (fc) return Tn;
  fc = 1;
  function e(t, r) {
    return t?.[r];
  }
  return Tn = e, Tn;
}
var qn, dc;
function Ze() {
  if (dc) return qn;
  dc = 1;
  var e = sm(), t = cm();
  function r(n, a) {
    var i = t(n, a);
    return e(i) ? i : void 0;
  }
  return qn = r, qn;
}
var jn, hc;
function br() {
  if (hc) return jn;
  hc = 1;
  var e = Ze(), t = e(Object, "create");
  return jn = t, jn;
}
var In, pc;
function um() {
  if (pc) return In;
  pc = 1;
  var e = br();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return In = t, In;
}
var Mn, vc;
function lm() {
  if (vc) return Mn;
  vc = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return Mn = e, Mn;
}
var Dn, gc;
function fm() {
  if (gc) return Dn;
  gc = 1;
  var e = br(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    var o = this.__data__;
    if (e) {
      var s = o[i];
      return s === t ? void 0 : s;
    }
    return n.call(o, i) ? o[i] : void 0;
  }
  return Dn = a, Dn;
}
var Fn, mc;
function dm() {
  if (mc) return Fn;
  mc = 1;
  var e = br(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var i = this.__data__;
    return e ? i[a] !== void 0 : r.call(i, a);
  }
  return Fn = n, Fn;
}
var Nn, bc;
function hm() {
  if (bc) return Nn;
  bc = 1;
  var e = br(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var i = this.__data__;
    return this.size += this.has(n) ? 0 : 1, i[n] = e && a === void 0 ? t : a, this;
  }
  return Nn = r, Nn;
}
var kn, yc;
function pm() {
  if (yc) return kn;
  yc = 1;
  var e = um(), t = lm(), r = fm(), n = dm(), a = hm();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, kn = i, kn;
}
var Ln, _c;
function vm() {
  if (_c) return Ln;
  _c = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Ln = e, Ln;
}
var Bn, xc;
function wo() {
  if (xc) return Bn;
  xc = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Bn = e, Bn;
}
var Vn, wc;
function yr() {
  if (wc) return Vn;
  wc = 1;
  var e = wo();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return Vn = t, Vn;
}
var Hn, Cc;
function gm() {
  if (Cc) return Hn;
  Cc = 1;
  var e = yr(), t = Array.prototype, r = t.splice;
  function n(a) {
    var i = this.__data__, o = e(i, a);
    if (o < 0)
      return !1;
    var s = i.length - 1;
    return o == s ? i.pop() : r.call(i, o, 1), --this.size, !0;
  }
  return Hn = n, Hn;
}
var zn, Rc;
function mm() {
  if (Rc) return zn;
  Rc = 1;
  var e = yr();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return zn = t, zn;
}
var Un, Sc;
function bm() {
  if (Sc) return Un;
  Sc = 1;
  var e = yr();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Un = t, Un;
}
var Wn, $c;
function ym() {
  if ($c) return Wn;
  $c = 1;
  var e = yr();
  function t(r, n) {
    var a = this.__data__, i = e(a, r);
    return i < 0 ? (++this.size, a.push([r, n])) : a[i][1] = n, this;
  }
  return Wn = t, Wn;
}
var Gn, Pc;
function _r() {
  if (Pc) return Gn;
  Pc = 1;
  var e = vm(), t = gm(), r = mm(), n = bm(), a = ym();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Gn = i, Gn;
}
var Kn, Ec;
function Co() {
  if (Ec) return Kn;
  Ec = 1;
  var e = Ze(), t = Oe(), r = e(t, "Map");
  return Kn = r, Kn;
}
var Yn, Oc;
function _m() {
  if (Oc) return Yn;
  Oc = 1;
  var e = pm(), t = _r(), r = Co();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Yn = n, Yn;
}
var Xn, Ac;
function xm() {
  if (Ac) return Xn;
  Ac = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Xn = e, Xn;
}
var Jn, Tc;
function xr() {
  if (Tc) return Jn;
  Tc = 1;
  var e = xm();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return Jn = t, Jn;
}
var Zn, qc;
function wm() {
  if (qc) return Zn;
  qc = 1;
  var e = xr();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Zn = t, Zn;
}
var Qn, jc;
function Cm() {
  if (jc) return Qn;
  jc = 1;
  var e = xr();
  function t(r) {
    return e(this, r).get(r);
  }
  return Qn = t, Qn;
}
var ea, Ic;
function Rm() {
  if (Ic) return ea;
  Ic = 1;
  var e = xr();
  function t(r) {
    return e(this, r).has(r);
  }
  return ea = t, ea;
}
var ta, Mc;
function Sm() {
  if (Mc) return ta;
  Mc = 1;
  var e = xr();
  function t(r, n) {
    var a = e(this, r), i = a.size;
    return a.set(r, n), this.size += a.size == i ? 0 : 1, this;
  }
  return ta = t, ta;
}
var ra, Dc;
function Ro() {
  if (Dc) return ra;
  Dc = 1;
  var e = _m(), t = wm(), r = Cm(), n = Rm(), a = Sm();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, ra = i, ra;
}
var na, Fc;
function $m() {
  if (Fc) return na;
  Fc = 1;
  var e = Ro(), t = "Expected a function";
  function r(n, a) {
    if (typeof n != "function" || a != null && typeof a != "function")
      throw new TypeError(t);
    var i = function() {
      var o = arguments, s = a ? a.apply(this, o) : o[0], c = i.cache;
      if (c.has(s))
        return c.get(s);
      var u = n.apply(this, o);
      return i.cache = c.set(s, u) || c, u;
    };
    return i.cache = new (r.Cache || e)(), i;
  }
  return r.Cache = e, na = r, na;
}
var aa, Nc;
function Pm() {
  if (Nc) return aa;
  Nc = 1;
  var e = $m(), t = 500;
  function r(n) {
    var a = e(n, function(o) {
      return i.size === t && i.clear(), o;
    }), i = a.cache;
    return a;
  }
  return aa = r, aa;
}
var ia, kc;
function Em() {
  if (kc) return ia;
  kc = 1;
  var e = Pm(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(a) {
    var i = [];
    return a.charCodeAt(0) === 46 && i.push(""), a.replace(t, function(o, s, c, u) {
      i.push(c ? u.replace(r, "$1") : s || o);
    }), i;
  });
  return ia = n, ia;
}
var oa, Lc;
function wr() {
  if (Lc) return oa;
  Lc = 1;
  var e = Se(), t = xo(), r = Em(), n = mr();
  function a(i, o) {
    return e(i) ? i : t(i, o) ? [i] : r(n(i));
  }
  return oa = a, oa;
}
var sa, Bc;
function It() {
  if (Bc) return sa;
  Bc = 1;
  var e = jt();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return sa = t, sa;
}
var ca, Vc;
function Cr() {
  if (Vc) return ca;
  Vc = 1;
  var e = wr(), t = It();
  function r(n, a) {
    a = e(a, n);
    for (var i = 0, o = a.length; n != null && i < o; )
      n = n[t(a[i++])];
    return i && i == o ? n : void 0;
  }
  return ca = r, ca;
}
var ua, Hc;
function Df() {
  if (Hc) return ua;
  Hc = 1;
  var e = Ze(), t = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return ua = t, ua;
}
var la, zc;
function Om() {
  if (zc) return la;
  zc = 1;
  var e = Df();
  function t(r, n, a) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return la = t, la;
}
var fa, Uc;
function Am() {
  if (Uc) return fa;
  Uc = 1;
  var e = Om(), t = wo(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i, o, s) {
    var c = i[o];
    (!(n.call(i, o) && t(c, s)) || s === void 0 && !(o in i)) && e(i, o, s);
  }
  return fa = a, fa;
}
var da, Wc;
function So() {
  if (Wc) return da;
  Wc = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var i = typeof n;
    return a = a ?? e, !!a && (i == "number" || i != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return da = r, da;
}
var ha, Gc;
function Tm() {
  if (Gc) return ha;
  Gc = 1;
  var e = Am(), t = wr(), r = So(), n = Je(), a = It();
  function i(o, s, c, u) {
    if (!n(o))
      return o;
    s = t(s, o);
    for (var h = -1, l = s.length, d = l - 1, f = o; f != null && ++h < l; ) {
      var g = a(s[h]), p = c;
      if (g === "__proto__" || g === "constructor" || g === "prototype")
        return o;
      if (h != d) {
        var m = f[g];
        p = u ? u(m, g, f) : void 0, p === void 0 && (p = n(m) ? m : r(s[h + 1]) ? [] : {});
      }
      e(f, g, p), f = f[g];
    }
    return o;
  }
  return ha = i, ha;
}
var pa, Kc;
function qm() {
  if (Kc) return pa;
  Kc = 1;
  var e = Cr(), t = Tm(), r = wr();
  function n(a, i, o) {
    for (var s = -1, c = i.length, u = {}; ++s < c; ) {
      var h = i[s], l = e(a, h);
      o(l, h) && t(u, r(h, a), l);
    }
    return u;
  }
  return pa = n, pa;
}
var va, Yc;
function jm() {
  if (Yc) return va;
  Yc = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return va = e, va;
}
var ga, Xc;
function Im() {
  if (Xc) return ga;
  Xc = 1;
  var e = Ye(), t = Xe(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return ga = n, ga;
}
var ma, Jc;
function $o() {
  if (Jc) return ma;
  Jc = 1;
  var e = Im(), t = Xe(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, i = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(o) {
    return t(o) && n.call(o, "callee") && !a.call(o, "callee");
  };
  return ma = i, ma;
}
var ba, Zc;
function Po() {
  if (Zc) return ba;
  Zc = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return ba = t, ba;
}
var ya, Qc;
function Mm() {
  if (Qc) return ya;
  Qc = 1;
  var e = wr(), t = $o(), r = Se(), n = So(), a = Po(), i = It();
  function o(s, c, u) {
    c = e(c, s);
    for (var h = -1, l = c.length, d = !1; ++h < l; ) {
      var f = i(c[h]);
      if (!(d = s != null && u(s, f)))
        break;
      s = s[f];
    }
    return d || ++h != l ? d : (l = s == null ? 0 : s.length, !!l && a(l) && n(f, l) && (r(s) || t(s)));
  }
  return ya = o, ya;
}
var _a, eu;
function Ff() {
  if (eu) return _a;
  eu = 1;
  var e = jm(), t = Mm();
  function r(n, a) {
    return n != null && t(n, a, e);
  }
  return _a = r, _a;
}
var xa, tu;
function Dm() {
  if (tu) return xa;
  tu = 1;
  var e = qm(), t = Ff();
  function r(n, a) {
    return e(n, a, function(i, o) {
      return t(n, o);
    });
  }
  return xa = r, xa;
}
var wa, ru;
function Nf() {
  if (ru) return wa;
  ru = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, i = t.length; ++n < a; )
      t[i + n] = r[n];
    return t;
  }
  return wa = e, wa;
}
var Ca, nu;
function Fm() {
  if (nu) return Ca;
  nu = 1;
  var e = qt(), t = $o(), r = Se(), n = e ? e.isConcatSpreadable : void 0;
  function a(i) {
    return r(i) || t(i) || !!(n && i && i[n]);
  }
  return Ca = a, Ca;
}
var Ra, au;
function Nm() {
  if (au) return Ra;
  au = 1;
  var e = Nf(), t = Fm();
  function r(n, a, i, o, s) {
    var c = -1, u = n.length;
    for (i || (i = t), s || (s = []); ++c < u; ) {
      var h = n[c];
      a > 0 && i(h) ? a > 1 ? r(h, a - 1, i, o, s) : e(s, h) : o || (s[s.length] = h);
    }
    return s;
  }
  return Ra = r, Ra;
}
var Sa, iu;
function km() {
  if (iu) return Sa;
  iu = 1;
  var e = Nm();
  function t(r) {
    var n = r == null ? 0 : r.length;
    return n ? e(r, 1) : [];
  }
  return Sa = t, Sa;
}
var $a, ou;
function Lm() {
  if (ou) return $a;
  ou = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return $a = e, $a;
}
var Pa, su;
function Bm() {
  if (su) return Pa;
  su = 1;
  var e = Lm(), t = Math.max;
  function r(n, a, i) {
    return a = t(a === void 0 ? n.length - 1 : a, 0), function() {
      for (var o = arguments, s = -1, c = t(o.length - a, 0), u = Array(c); ++s < c; )
        u[s] = o[a + s];
      s = -1;
      for (var h = Array(a + 1); ++s < a; )
        h[s] = o[s];
      return h[a] = i(u), e(n, this, h);
    };
  }
  return Pa = r, Pa;
}
var Ea, cu;
function Vm() {
  if (cu) return Ea;
  cu = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Ea = e, Ea;
}
var Oa, uu;
function Rr() {
  if (uu) return Oa;
  uu = 1;
  function e(t) {
    return t;
  }
  return Oa = e, Oa;
}
var Aa, lu;
function Hm() {
  if (lu) return Aa;
  lu = 1;
  var e = Vm(), t = Df(), r = Rr(), n = t ? function(a, i) {
    return t(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : r;
  return Aa = n, Aa;
}
var Ta, fu;
function zm() {
  if (fu) return Ta;
  fu = 1;
  var e = 800, t = 16, r = Date.now;
  function n(a) {
    var i = 0, o = 0;
    return function() {
      var s = r(), c = t - (s - o);
      if (o = s, c > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Ta = n, Ta;
}
var qa, du;
function Um() {
  if (du) return qa;
  du = 1;
  var e = Hm(), t = zm(), r = t(e);
  return qa = r, qa;
}
var ja, hu;
function Wm() {
  if (hu) return ja;
  hu = 1;
  var e = km(), t = Bm(), r = Um();
  function n(a) {
    return r(t(a, void 0, e), a + "");
  }
  return ja = n, ja;
}
var Ia, pu;
function Gm() {
  if (pu) return Ia;
  pu = 1;
  var e = Dm(), t = Wm(), r = t(function(n, a) {
    return n == null ? {} : e(n, a);
  });
  return Ia = r, Ia;
}
var Km = Gm();
const Ym = /* @__PURE__ */ Re(Km);
var Ma, vu;
function Xm() {
  if (vu) return Ma;
  vu = 1;
  function e(t, r) {
    for (var n, a = -1, i = t.length; ++a < i; ) {
      var o = r(t[a]);
      o !== void 0 && (n = n === void 0 ? o : n + o);
    }
    return n;
  }
  return Ma = e, Ma;
}
var Da, gu;
function Jm() {
  if (gu) return Da;
  gu = 1;
  var e = Xm(), t = Rr();
  function r(n) {
    return n && n.length ? e(n, t) : 0;
  }
  return Da = r, Da;
}
var Zm = Jm();
const Qm = /* @__PURE__ */ Re(Zm), eb = (e) => {
  const { outerRadius: t } = e;
  return /* @__PURE__ */ b.jsxs("g", { children: [
    /* @__PURE__ */ b.jsx(Ho, { ...e }),
    /* @__PURE__ */ b.jsx(
      Ho,
      {
        ...e,
        innerRadius: t,
        outerRadius: t + 10,
        fillOpacity: 0.4
      }
    )
  ] });
}, tb = (e) => {
  const { name: t, value: r, cx: n, cy: a, midAngle: i, outerRadius: o, fill: s, percent: c } = e, u = !!r, h = typeof c == "number" && c >= 0.01;
  if (!u || !h || !(typeof n == "number" && typeof a == "number" && typeof i == "number" && typeof o == "number"))
    return null;
  const d = Math.PI / 180, f = o + 24, g = n + o * Math.cos(-i * d), p = a + o * Math.sin(-i * d), m = n + f * Math.cos(-i * d), y = a + f * Math.sin(-i * d), _ = m + (m > n ? 12 : -12), R = y;
  return /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    /* @__PURE__ */ b.jsx(
      "polyline",
      {
        points: `${g},${p} ${m},${y} ${_},${R}`,
        stroke: s,
        fill: "none",
        strokeWidth: 1
      }
    ),
    /* @__PURE__ */ b.jsx(
      "text",
      {
        ...qe.tickProps,
        fill: kd.color.secondary,
        x: _ + (_ > n ? 8 : -8),
        y: R,
        textAnchor: _ > n ? "start" : "end",
        dominantBaseline: "middle",
        children: t
      }
    )
  ] });
}, rb = ({
  instrument: e,
  legend: t,
  hoveredLegend: r,
  hoveredCategory: n
}) => {
  const { data: a, layout: i } = e, o = U(() => {
    const { categories: l, series: d } = a, f = d.filter(({ label: y }) => t.includes(y)), g = i === "vertical", p = g ? [0, 2, 2, 0] : [2, 2, 0, 0];
    return d.map(
      ({ label: y, options: _, data: R }, C) => {
        const S = st(
          C,
          a.options?.theme,
          _?.color
        ), P = _?.stack, T = P ? f.filter((A) => A.options?.stack === P) : [], w = P ? am(T)?.label === y : !0, x = vr(a.formats), E = f.length <= 10 && (P ? w : !0), $ = /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
          E && /* @__PURE__ */ b.jsx(
            wd,
            {
              position: g ? "right" : "top",
              valueAccessor: ({ payload: A }) => (
                // In the case of stacked series, the total sum of all
                // visible series values for the current category is
                // displayed. For individual series, their own value is
                // displayed by using their `label` from the Recharts data.
                P ? Qm(
                  Object.values(
                    Ym(
                      A,
                      T.map((q) => q.label)
                    )
                  )
                ) : Number(A[y] ?? 0)
              ),
              formatter: (A) => A ? Tt(A, x) : "",
              ...qe.tickProps,
              offset: 8,
              fontSize: "var(--dixa-typography-size-100)",
              width: 0
            }
          ),
          R.map((A, q) => {
            const F = d.length > 1 ? S : st(
              q,
              a.options?.theme,
              // If there is only one series, the category color is used if specified, otherwise
              // the colors are determined by the category index, resulting in different colors
              // being used for each category and repeating as necessary.
              l[q]?.options?.color ?? _?.color
            ), M = n === null || n === q, N = r === null || r === y;
            return /* @__PURE__ */ b.jsx(
              zo,
              {
                fill: F,
                fillOpacity: M && N ? 1 : 0.4
              },
              `${y}-${q}`
            );
          })
        ] });
        return {
          key: y,
          dataKey: y,
          stackId: P,
          fill: S,
          radius: w ? p : 0,
          maxBarSize: 80,
          hide: !t.includes(y),
          children: $
        };
      }
    );
  }, [a, n, r, i, t]), s = U(() => {
    const { series: l } = a;
    return l.map(({ label: f, options: g }, p) => {
      const m = st(
        p,
        a.options?.theme,
        g?.color
      );
      return {
        key: f,
        type: "monotone",
        dot: !1,
        activeDot: { r: 5 },
        dataKey: f,
        stroke: m,
        strokeWidth: 2,
        strokeOpacity: r === null || r === f ? 1 : 0.4,
        connectNulls: !0,
        hide: !t.includes(f)
      };
    });
  }, [a, r, t]), c = U(() => {
    const { series: l } = a;
    return l.map(({ label: f, options: g }, p) => {
      const m = st(
        p,
        a.options?.theme,
        g?.color
      ), y = r === null || r === f;
      return {
        key: f,
        type: "monotone",
        dot: !1,
        activeDot: { r: 5 },
        dataKey: f,
        stackId: g?.stack,
        stroke: m,
        strokeWidth: 2,
        fill: m,
        fillOpacity: y ? 0.9 : 0.2,
        strokeOpacity: y ? 1 : 0,
        connectNulls: !0,
        hide: !t.includes(f)
      };
    });
  }, [a, r, t]), u = U(
    (l) => {
      const { categories: d, series: f } = a, g = d.map(
        ({ label: p, options: m }, y) => {
          const _ = st(
            y,
            a.options?.theme,
            m?.color
          );
          return /* @__PURE__ */ b.jsx(zo, { fill: _, style: { outline: "none" } }, p);
        }
      );
      return {
        dataKey: f[0]?.label,
        cx: "50%",
        cy: "50%",
        label: tb,
        labelLine: !1,
        activeShape: eb,
        inactiveShape: {
          fillOpacity: 0.4
        },
        stroke: Ml.neutral["000"],
        strokeWidth: 1.5,
        innerRadius: l === "donut" ? "50%" : 0,
        outerRadius: "80%",
        startAngle: 90,
        endAngle: -270,
        children: g
      };
    },
    [a]
  );
  return { getSeriesProps: U(
    (l) => {
      switch (l) {
        case "bar":
          return o();
        case "line":
          return s();
        case "area":
          return c();
        case "pie":
        case "donut":
          return u(
            l
          );
        default:
          return [];
      }
      return [];
    },
    [c, o, s, u]
  ) };
}, i0 = ye(function({
  instrument: t,
  panel: r,
  timezone: n,
  syncOptions: a,
  onChangeGranularity: i,
  onChangeVisualization: o,
  onChangeFormat: s
}) {
  const [c, u] = te(
    r.controls?.settings.visualization ?? t.visualization
  ), [h, l] = te(null), { data: d, layout: f, title: g } = t, p = f === "horizontal", m = f === "vertical", y = W(
    () => mg(d, { omitZero: c === "bar" }),
    [d, c]
  ), _ = W(
    () => d.granularities?.find(({ selected: N }) => N)?.value,
    [d.granularities]
  ), R = W(() => {
    if (!d.options?.visualizations) return [];
    const N = ["bar"], L = d.series.length === 1;
    return d.categories.every(
      ({ label: ne }) => cr(ne)
    ) ? N.push("line", "area") : L && N.push("pie", "donut"), N;
  }, [d.categories, d.options?.visualizations, d.series.length]), { xAxisProps: C, yAxisProps: S } = zg({
    instrument: t,
    granularity: _,
    timezone: n,
    syncOptions: a
  }), { legend: P, legendProps: T, hoveredLegend: w } = tm({
    instrument: t,
    visualization: c
  }), { getSeriesProps: x } = rb({
    instrument: t,
    legend: P,
    hoveredLegend: w,
    hoveredCategory: h
  });
  Ot(() => {
    u(
      r.controls?.settings.visualization ?? t.visualization
    );
  }, [r.controls?.settings.visualization, t.visualization]);
  const E = U(
    (N) => {
      u(N), o?.(N);
    },
    [o]
  ), $ = (N) => {
    if (!N?.isTooltipActive) {
      l(null);
      return;
    }
    const L = N.activeTooltipIndex;
    if (typeof L != "number") return;
    const G = Object.values(y[L] ?? {}).length > 1;
    l(G ? L : null);
  }, I = () => {
    l(null);
  }, A = () => c === "line" ? x(c).map(({ key: L, ...G }) => /* @__PURE__ */ b.jsx(Md, { ...G }, L)) : c === "bar" ? x(c).map(({ key: L, ...G }) => /* @__PURE__ */ b.jsx(Dd, { ...G }, L)) : c === "area" ? x(c).map(({ key: L, ...G }) => /* @__PURE__ */ b.jsx(Fd, { ...G }, L)) : c === "pie" || c === "donut" ? /* @__PURE__ */ b.jsx(Nd, { data: y, ...x(c) }) : null, q = () => {
    const N = d.options?.legend?.layout, L = 16, G = {
      layout: f,
      syncId: a?.tooltip ? r.id : void 0,
      data: y,
      margin: {
        top: p ? L : 0,
        right: m || N === "vertical" ? L : 0,
        bottom: N === "horizontal" ? L / 2 : 0,
        left: 0
      }
    }, ne = c === "bar" || c === "line" || c === "area", ae = /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
      ne && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
        /* @__PURE__ */ b.jsx(Rd, { ...C }),
        /* @__PURE__ */ b.jsx(Sd, { ...S })
      ] }),
      ne && d.options?.cartesian && /* @__PURE__ */ b.jsx(
        $d,
        {
          vertical: m,
          horizontal: p,
          stroke: "var(--dixa-color-neutral-200)"
        }
      ),
      ne && d.references?.map(({ value: ce, label: oe }, ue) => /* @__PURE__ */ b.jsx(
        Pd,
        {
          ...p ? { y: ce } : { x: ce },
          stroke: "var(--dixa-color-neutral-500)",
          strokeDasharray: "5 5",
          isFront: !0,
          children: /* @__PURE__ */ b.jsx(
            Ed,
            {
              value: oe,
              offset: 8,
              fontSize: "var(--dixa-typography-size-200)",
              position: p ? "insideBottomLeft" : "insideTopLeft"
            }
          )
        },
        ue
      )),
      d.options?.legend && /* @__PURE__ */ b.jsx(Od, { ...T }),
      d.options?.tooltip && /* @__PURE__ */ b.jsx(
        Ad,
        {
          content: (ce) => /* @__PURE__ */ b.jsx(
            Fg,
            {
              instrument: t,
              granularity: _,
              timezone: n,
              tooltipProps: ce
            }
          ),
          cursor: { fill: "transparent" }
        }
      ),
      A()
    ] });
    switch (c) {
      case "bar":
        return /* @__PURE__ */ b.jsx(
          Id,
          {
            ...G,
            barGap: "1",
            onMouseMove: $,
            onMouseLeave: I,
            children: ae
          }
        );
      case "line":
        return /* @__PURE__ */ b.jsx(jd, { ...G, children: ae });
      case "area":
        return /* @__PURE__ */ b.jsx(qd, { ...G, children: ae });
      case "pie":
      case "donut":
        return /* @__PURE__ */ b.jsx(Td, { ...G, children: ae });
    }
  };
  if (!d.categories.length || !d.series.length)
    return /* @__PURE__ */ b.jsx(
      J,
      {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        children: /* @__PURE__ */ b.jsx(
          ql,
          {
            title: "No data available",
            description: "There is no data available for the selected period and filters.",
            icon: qe.visualizationIcons[c]
          }
        )
      }
    );
  const F = [
    d.formats && d.formats.length > 1 ? /* @__PURE__ */ b.jsx(
      og,
      {
        formats: d.formats,
        onChangeFormat: s
      },
      "format"
    ) : null,
    d.granularities && d.granularities.length > 1 ? /* @__PURE__ */ b.jsx(
      sg,
      {
        granularities: d.granularities,
        onChangeGranularity: i
      },
      "granularity"
    ) : null,
    d.options?.visualizations ? /* @__PURE__ */ b.jsx(
      Hg,
      {
        visualization: c,
        visualizations: R,
        onChangeVisualization: E
      },
      "visualization"
    ) : null
  ], M = F.some(Boolean);
  return /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    g && /* @__PURE__ */ b.jsx("div", { children: /* @__PURE__ */ b.jsx(Y.Heading, { variant: "heading-4", children: g }) }),
    M && /* @__PURE__ */ b.jsx(J, { alignSelf: "flex-end", gap: "300", children: F.map((N, L) => /* @__PURE__ */ b.jsx(Tl, { children: N }, L)) }),
    /* @__PURE__ */ b.jsx(
      Cd,
      {
        className: rg.container,
        width: "100%",
        height: "100%",
        debounce: 100,
        children: q()
      }
    )
  ] });
});
var Fa, mu;
function nb() {
  if (mu) return Fa;
  mu = 1;
  var e = _r();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Fa = t, Fa;
}
var Na, bu;
function ab() {
  if (bu) return Na;
  bu = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Na = e, Na;
}
var ka, yu;
function ib() {
  if (yu) return ka;
  yu = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return ka = e, ka;
}
var La, _u;
function ob() {
  if (_u) return La;
  _u = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return La = e, La;
}
var Ba, xu;
function sb() {
  if (xu) return Ba;
  xu = 1;
  var e = _r(), t = Co(), r = Ro(), n = 200;
  function a(i, o) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!t || c.length < n - 1)
        return c.push([i, o]), this.size = ++s.size, this;
      s = this.__data__ = new r(c);
    }
    return s.set(i, o), this.size = s.size, this;
  }
  return Ba = a, Ba;
}
var Va, wu;
function kf() {
  if (wu) return Va;
  wu = 1;
  var e = _r(), t = nb(), r = ab(), n = ib(), a = ob(), i = sb();
  function o(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return o.prototype.clear = t, o.prototype.delete = r, o.prototype.get = n, o.prototype.has = a, o.prototype.set = i, Va = o, Va;
}
var Ha, Cu;
function cb() {
  if (Cu) return Ha;
  Cu = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return Ha = t, Ha;
}
var za, Ru;
function ub() {
  if (Ru) return za;
  Ru = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return za = e, za;
}
var Ua, Su;
function lb() {
  if (Su) return Ua;
  Su = 1;
  var e = Ro(), t = cb(), r = ub();
  function n(a) {
    var i = -1, o = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++i < o; )
      this.add(a[i]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, Ua = n, Ua;
}
var Wa, $u;
function fb() {
  if ($u) return Wa;
  $u = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Wa = e, Wa;
}
var Ga, Pu;
function db() {
  if (Pu) return Ga;
  Pu = 1;
  function e(t, r) {
    return t.has(r);
  }
  return Ga = e, Ga;
}
var Ka, Eu;
function Lf() {
  if (Eu) return Ka;
  Eu = 1;
  var e = lb(), t = fb(), r = db(), n = 1, a = 2;
  function i(o, s, c, u, h, l) {
    var d = c & n, f = o.length, g = s.length;
    if (f != g && !(d && g > f))
      return !1;
    var p = l.get(o), m = l.get(s);
    if (p && m)
      return p == s && m == o;
    var y = -1, _ = !0, R = c & a ? new e() : void 0;
    for (l.set(o, s), l.set(s, o); ++y < f; ) {
      var C = o[y], S = s[y];
      if (u)
        var P = d ? u(S, C, y, s, o, l) : u(C, S, y, o, s, l);
      if (P !== void 0) {
        if (P)
          continue;
        _ = !1;
        break;
      }
      if (R) {
        if (!t(s, function(T, w) {
          if (!r(R, w) && (C === T || h(C, T, c, u, l)))
            return R.push(w);
        })) {
          _ = !1;
          break;
        }
      } else if (!(C === S || h(C, S, c, u, l))) {
        _ = !1;
        break;
      }
    }
    return l.delete(o), l.delete(s), _;
  }
  return Ka = i, Ka;
}
var Ya, Ou;
function hb() {
  if (Ou) return Ya;
  Ou = 1;
  var e = Oe(), t = e.Uint8Array;
  return Ya = t, Ya;
}
var Xa, Au;
function pb() {
  if (Au) return Xa;
  Au = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, i) {
      n[++r] = [i, a];
    }), n;
  }
  return Xa = e, Xa;
}
var Ja, Tu;
function vb() {
  if (Tu) return Ja;
  Tu = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return Ja = e, Ja;
}
var Za, qu;
function gb() {
  if (qu) return Za;
  qu = 1;
  var e = qt(), t = hb(), r = wo(), n = Lf(), a = pb(), i = vb(), o = 1, s = 2, c = "[object Boolean]", u = "[object Date]", h = "[object Error]", l = "[object Map]", d = "[object Number]", f = "[object RegExp]", g = "[object Set]", p = "[object String]", m = "[object Symbol]", y = "[object ArrayBuffer]", _ = "[object DataView]", R = e ? e.prototype : void 0, C = R ? R.valueOf : void 0;
  function S(P, T, w, x, E, $, I) {
    switch (w) {
      case _:
        if (P.byteLength != T.byteLength || P.byteOffset != T.byteOffset)
          return !1;
        P = P.buffer, T = T.buffer;
      case y:
        return !(P.byteLength != T.byteLength || !$(new t(P), new t(T)));
      case c:
      case u:
      case d:
        return r(+P, +T);
      case h:
        return P.name == T.name && P.message == T.message;
      case f:
      case p:
        return P == T + "";
      case l:
        var A = a;
      case g:
        var q = x & o;
        if (A || (A = i), P.size != T.size && !q)
          return !1;
        var F = I.get(P);
        if (F)
          return F == T;
        x |= s, I.set(P, T);
        var M = n(A(P), A(T), x, E, $, I);
        return I.delete(P), M;
      case m:
        if (C)
          return C.call(P) == C.call(T);
    }
    return !1;
  }
  return Za = S, Za;
}
var Qa, ju;
function mb() {
  if (ju) return Qa;
  ju = 1;
  var e = Nf(), t = Se();
  function r(n, a, i) {
    var o = a(n);
    return t(n) ? o : e(o, i(n));
  }
  return Qa = r, Qa;
}
var ei, Iu;
function bb() {
  if (Iu) return ei;
  Iu = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = 0, o = []; ++n < a; ) {
      var s = t[n];
      r(s, n, t) && (o[i++] = s);
    }
    return o;
  }
  return ei = e, ei;
}
var ti, Mu;
function yb() {
  if (Mu) return ti;
  Mu = 1;
  function e() {
    return [];
  }
  return ti = e, ti;
}
var ri, Du;
function _b() {
  if (Du) return ri;
  Du = 1;
  var e = bb(), t = yb(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, i = a ? function(o) {
    return o == null ? [] : (o = Object(o), e(a(o), function(s) {
      return n.call(o, s);
    }));
  } : t;
  return ri = i, ri;
}
var ni, Fu;
function xb() {
  if (Fu) return ni;
  Fu = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return ni = e, ni;
}
var wt = { exports: {} }, ai, Nu;
function wb() {
  if (Nu) return ai;
  Nu = 1;
  function e() {
    return !1;
  }
  return ai = e, ai;
}
wt.exports;
var ku;
function Bf() {
  return ku || (ku = 1, (function(e, t) {
    var r = Oe(), n = wb(), a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, c = s ? s.isBuffer : void 0, u = c || n;
    e.exports = u;
  })(wt, wt.exports)), wt.exports;
}
var ii, Lu;
function Cb() {
  if (Lu) return ii;
  Lu = 1;
  var e = Ye(), t = Po(), r = Xe(), n = "[object Arguments]", a = "[object Array]", i = "[object Boolean]", o = "[object Date]", s = "[object Error]", c = "[object Function]", u = "[object Map]", h = "[object Number]", l = "[object Object]", d = "[object RegExp]", f = "[object Set]", g = "[object String]", p = "[object WeakMap]", m = "[object ArrayBuffer]", y = "[object DataView]", _ = "[object Float32Array]", R = "[object Float64Array]", C = "[object Int8Array]", S = "[object Int16Array]", P = "[object Int32Array]", T = "[object Uint8Array]", w = "[object Uint8ClampedArray]", x = "[object Uint16Array]", E = "[object Uint32Array]", $ = {};
  $[_] = $[R] = $[C] = $[S] = $[P] = $[T] = $[w] = $[x] = $[E] = !0, $[n] = $[a] = $[m] = $[i] = $[y] = $[o] = $[s] = $[c] = $[u] = $[h] = $[l] = $[d] = $[f] = $[g] = $[p] = !1;
  function I(A) {
    return r(A) && t(A.length) && !!$[e(A)];
  }
  return ii = I, ii;
}
var oi, Bu;
function Vf() {
  if (Bu) return oi;
  Bu = 1;
  var e = Cb(), t = _o(), r = Ef(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return oi = a, oi;
}
var si, Vu;
function Rb() {
  if (Vu) return si;
  Vu = 1;
  var e = xb(), t = $o(), r = Se(), n = Bf(), a = So(), i = Vf(), o = Object.prototype, s = o.hasOwnProperty;
  function c(u, h) {
    var l = r(u), d = !l && t(u), f = !l && !d && n(u), g = !l && !d && !f && i(u), p = l || d || f || g, m = p ? e(u.length, String) : [], y = m.length;
    for (var _ in u)
      (h || s.call(u, _)) && !(p && // Safari 9 has enumerable `arguments.length` in strict mode.
      (_ == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      f && (_ == "offset" || _ == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (_ == "buffer" || _ == "byteLength" || _ == "byteOffset") || // Skip index properties.
      a(_, y))) && m.push(_);
    return m;
  }
  return si = c, si;
}
var ci, Hu;
function Sb() {
  if (Hu) return ci;
  Hu = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return ci = t, ci;
}
var ui, zu;
function $b() {
  if (zu) return ui;
  zu = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return ui = e, ui;
}
var li, Uu;
function Pb() {
  if (Uu) return li;
  Uu = 1;
  var e = $b(), t = e(Object.keys, Object);
  return li = t, li;
}
var fi, Wu;
function Eb() {
  if (Wu) return fi;
  Wu = 1;
  var e = Sb(), t = Pb(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    if (!e(i))
      return t(i);
    var o = [];
    for (var s in Object(i))
      n.call(i, s) && s != "constructor" && o.push(s);
    return o;
  }
  return fi = a, fi;
}
var di, Gu;
function Eo() {
  if (Gu) return di;
  Gu = 1;
  var e = If(), t = Po();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return di = r, di;
}
var hi, Ku;
function Oo() {
  if (Ku) return hi;
  Ku = 1;
  var e = Rb(), t = Eb(), r = Eo();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return hi = n, hi;
}
var pi, Yu;
function Ob() {
  if (Yu) return pi;
  Yu = 1;
  var e = mb(), t = _b(), r = Oo();
  function n(a) {
    return e(a, r, t);
  }
  return pi = n, pi;
}
var vi, Xu;
function Ab() {
  if (Xu) return vi;
  Xu = 1;
  var e = Ob(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(i, o, s, c, u, h) {
    var l = s & t, d = e(i), f = d.length, g = e(o), p = g.length;
    if (f != p && !l)
      return !1;
    for (var m = f; m--; ) {
      var y = d[m];
      if (!(l ? y in o : n.call(o, y)))
        return !1;
    }
    var _ = h.get(i), R = h.get(o);
    if (_ && R)
      return _ == o && R == i;
    var C = !0;
    h.set(i, o), h.set(o, i);
    for (var S = l; ++m < f; ) {
      y = d[m];
      var P = i[y], T = o[y];
      if (c)
        var w = l ? c(T, P, y, o, i, h) : c(P, T, y, i, o, h);
      if (!(w === void 0 ? P === T || u(P, T, s, c, h) : w)) {
        C = !1;
        break;
      }
      S || (S = y == "constructor");
    }
    if (C && !S) {
      var x = i.constructor, E = o.constructor;
      x != E && "constructor" in i && "constructor" in o && !(typeof x == "function" && x instanceof x && typeof E == "function" && E instanceof E) && (C = !1);
    }
    return h.delete(i), h.delete(o), C;
  }
  return vi = a, vi;
}
var gi, Ju;
function Tb() {
  if (Ju) return gi;
  Ju = 1;
  var e = Ze(), t = Oe(), r = e(t, "DataView");
  return gi = r, gi;
}
var mi, Zu;
function qb() {
  if (Zu) return mi;
  Zu = 1;
  var e = Ze(), t = Oe(), r = e(t, "Promise");
  return mi = r, mi;
}
var bi, Qu;
function jb() {
  if (Qu) return bi;
  Qu = 1;
  var e = Ze(), t = Oe(), r = e(t, "Set");
  return bi = r, bi;
}
var yi, el;
function Ib() {
  if (el) return yi;
  el = 1;
  var e = Ze(), t = Oe(), r = e(t, "WeakMap");
  return yi = r, yi;
}
var _i, tl;
function Mb() {
  if (tl) return _i;
  tl = 1;
  var e = Tb(), t = Co(), r = qb(), n = jb(), a = Ib(), i = Ye(), o = Mf(), s = "[object Map]", c = "[object Object]", u = "[object Promise]", h = "[object Set]", l = "[object WeakMap]", d = "[object DataView]", f = o(e), g = o(t), p = o(r), m = o(n), y = o(a), _ = i;
  return (e && _(new e(new ArrayBuffer(1))) != d || t && _(new t()) != s || r && _(r.resolve()) != u || n && _(new n()) != h || a && _(new a()) != l) && (_ = function(R) {
    var C = i(R), S = C == c ? R.constructor : void 0, P = S ? o(S) : "";
    if (P)
      switch (P) {
        case f:
          return d;
        case g:
          return s;
        case p:
          return u;
        case m:
          return h;
        case y:
          return l;
      }
    return C;
  }), _i = _, _i;
}
var xi, rl;
function Db() {
  if (rl) return xi;
  rl = 1;
  var e = kf(), t = Lf(), r = gb(), n = Ab(), a = Mb(), i = Se(), o = Bf(), s = Vf(), c = 1, u = "[object Arguments]", h = "[object Array]", l = "[object Object]", d = Object.prototype, f = d.hasOwnProperty;
  function g(p, m, y, _, R, C) {
    var S = i(p), P = i(m), T = S ? h : a(p), w = P ? h : a(m);
    T = T == u ? l : T, w = w == u ? l : w;
    var x = T == l, E = w == l, $ = T == w;
    if ($ && o(p)) {
      if (!o(m))
        return !1;
      S = !0, x = !1;
    }
    if ($ && !x)
      return C || (C = new e()), S || s(p) ? t(p, m, y, _, R, C) : r(p, m, T, y, _, R, C);
    if (!(y & c)) {
      var I = x && f.call(p, "__wrapped__"), A = E && f.call(m, "__wrapped__");
      if (I || A) {
        var q = I ? p.value() : p, F = A ? m.value() : m;
        return C || (C = new e()), R(q, F, y, _, C);
      }
    }
    return $ ? (C || (C = new e()), n(p, m, y, _, R, C)) : !1;
  }
  return xi = g, xi;
}
var wi, nl;
function Ao() {
  if (nl) return wi;
  nl = 1;
  var e = Db(), t = Xe();
  function r(n, a, i, o, s) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, i, o, r, s);
  }
  return wi = r, wi;
}
var Ci, al;
function Fb() {
  if (al) return Ci;
  al = 1;
  var e = Ao();
  function t(r, n) {
    return e(r, n);
  }
  return Ci = t, Ci;
}
var Nb = Fb();
const kb = /* @__PURE__ */ Re(Nb);
var Ri, il;
function Lb() {
  if (il) return Ri;
  il = 1;
  var e = Ye(), t = Xe(), r = "[object Number]";
  function n(a) {
    return typeof a == "number" || t(a) && e(a) == r;
  }
  return Ri = n, Ri;
}
var Bb = Lb();
const Hf = /* @__PURE__ */ Re(Bb), Vb = "_trigger_1mrk9_1", Hb = {
  trigger: Vb
}, zb = ye(function({
  title: t,
  metrics: r,
  children: n
}) {
  const a = /* @__PURE__ */ b.jsxs(J, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "1", color: "inherit", children: t }),
    r.length > 0 && /* @__PURE__ */ b.jsx(ro, { bounded: !0, children: r.map((i, o) => /* @__PURE__ */ b.jsx(Cf, { instrument: i, theme: "dark" }, o)) })
  ] });
  return /* @__PURE__ */ b.jsx(
    Et,
    {
      content: a,
      wrap: "div",
      wrapProps: { className: Hb.trigger },
      children: n
    }
  );
}), Ub = "_cell_hfkay_1", Wb = "_cellText_hfkay_11", Gb = "_cellDimmed_hfkay_14", Kb = "_cellContent_hfkay_18", yt = {
  cell: Ub,
  cellText: Wb,
  cellDimmed: Gb,
  cellContent: Kb
}, Ut = ye(function({
  cell: t,
  dimmed: r = !1,
  background: n = "transparent",
  tooltipProps: a,
  textProps: i = {},
  onMouseEnter: o
}) {
  const [s, c] = te(!1), u = Il(t?.value);
  Ot(() => {
    if (t?.value !== u) {
      c(!0);
      const d = setTimeout(() => {
        c(!1);
      }, 200);
      return () => {
        clearTimeout(d);
      };
    }
  }, [t?.value]);
  const h = W(() => {
    if (!t) return null;
    const { value: d, format: f } = t;
    return typeof d == "string" ? d : typeof d == "number" && f ? Tt(d, f) : "—";
  }, [t]);
  if (!t)
    return /* @__PURE__ */ b.jsx(
      "div",
      {
        className: yt.cell,
        onMouseEnter: o,
        "data-testid": "heatmap-instrument-cell"
      }
    );
  const l = /* @__PURE__ */ b.jsx("div", { className: yt.cellContent, children: /* @__PURE__ */ b.jsx(
    Y.Paragraph,
    {
      className: je({
        [yt.cellText]: typeof t.value == "string"
      }),
      variant: "3",
      subdued: !Hf(t.value),
      ...i,
      children: h
    }
  ) });
  return /* @__PURE__ */ b.jsx(
    "div",
    {
      className: je(yt.cell, {
        [yt.cellDimmed]: r || s
      }),
      onMouseEnter: o,
      style: { backgroundColor: n },
      "data-animating": s,
      "data-testid": "heatmap-instrument-cell",
      children: a?.enabled ? /* @__PURE__ */ b.jsx(zb, { ...a, children: l }) : l
    }
  );
}), Yb = "_grid_1qk2p_1", Xb = "_row_1qk2p_7", Si = {
  grid: Yb,
  row: Xb
};
var ol = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Jb(e, t) {
  return !!(e === t || ol(e) && ol(t));
}
function Zb(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!Jb(e[r], t[r]))
      return !1;
  return !0;
}
function Qb(e, t) {
  t === void 0 && (t = Zb);
  var r = null;
  function n() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    if (r && r.lastThis === this && t(a, r.lastArgs))
      return r.lastResult;
    var o = e.apply(this, a);
    return r = {
      lastResult: o,
      lastArgs: a,
      lastThis: this
    }, o;
  }
  return n.clear = function() {
    r = null;
  }, n;
}
const ey = [
  "100",
  "200",
  "400",
  "500",
  "700"
].map((e) => `var(--dixa-color-purple-${e})`), ty = Qb(
  (e) => {
    if (e === null)
      return {
        backgroundColor: "var(--dixa-color-neutral-000)",
        color: "tertiary"
      };
    const t = Math.min(
      4,
      Math.floor(Math.min(e, 100) * (5 / 100))
    );
    return {
      backgroundColor: ey?.[t] ?? "var(--dixa-color-neutral-000)",
      color: t >= 3 ? "white" : "primary"
    };
  }
);
function ry(e) {
  return typeof e == "number" && !Number.isNaN(e) && e >= 0;
}
const ny = (e) => {
  const t = e.flatMap(({ data: a }) => a.map((i) => pr(i).value)).filter(ry), r = Math.min(...t), n = Math.max(...t);
  return { min: r, max: n };
}, ay = (e, { min: t, max: r }) => t === r ? 100 : Math.round(100 * (e - t) / (r - t)), o0 = ({
  instrument: e
}) => {
  const {
    data: { categories: t, series: r }
  } = e, n = ee(null), [a, i] = xd({
    cell: null,
    column: null,
    row: null
  }), o = W(
    () => Object.values(a).some((f) => f !== null),
    [a]
  ), s = W(() => ny(r), [r]);
  Pt(() => {
    const f = (g) => {
      n.current && !n.current.contains(g.target) && o && i.reset();
    };
    return window.addEventListener("mousemove", f, !0), () => {
      window.removeEventListener("mousemove", f, !0);
    };
  }, [o, i]);
  const c = U(
    (f) => {
      if (!o)
        return !1;
      const [g, p] = f;
      return a.cell ? !kb(a.cell.id, f) : a.column !== null ? a.column !== p : a.row !== null ? a.row !== g : !1;
    },
    [o, a.cell, a.column, a.row]
  ), u = U(
    (f) => i.setAll({
      cell: null,
      column: f,
      row: null
    }),
    [i]
  ), h = U(
    (f) => i.setAll({
      cell: null,
      column: null,
      row: f
    }),
    [i]
  ), l = U(
    (f) => {
      (o || f !== null) && i.setAll({
        cell: f,
        column: null,
        row: null
      });
    },
    [o, i]
  ), d = U(() => {
    o && i.reset();
  }, [o, i]);
  return /* @__PURE__ */ b.jsxs(
    "div",
    {
      ref: n,
      className: Si.grid,
      onMouseLeave: () => i.reset(),
      "data-testid": "heatmap-instrument",
      children: [
        /* @__PURE__ */ b.jsxs("div", { className: Si.row, children: [
          /* @__PURE__ */ b.jsx(Ut, { onMouseEnter: d }),
          r.map((f, g) => {
            const p = r[g].metrics ?? [];
            return /* @__PURE__ */ b.jsx(
              Ut,
              {
                cell: { id: [0, g], value: f.label },
                tooltipProps: {
                  enabled: p.length > 0,
                  title: f.label,
                  metrics: p
                },
                onMouseEnter: () => u(g)
              },
              f.label
            );
          })
        ] }),
        t.map((f, g) => {
          const p = t[g].metrics ?? [];
          return /* @__PURE__ */ b.jsxs("div", { className: Si.row, children: [
            /* @__PURE__ */ b.jsx(
              Ut,
              {
                cell: { id: [g, 0], value: f.label },
                tooltipProps: {
                  enabled: p.length > 0,
                  title: f.label,
                  metrics: p
                },
                onMouseEnter: () => h(g)
              }
            ),
            r.map((m, y) => {
              const _ = [g, y], { value: R, metrics: C } = pr(
                m.data[g]
              ), S = vr(e.data.formats), P = Hf(R), { backgroundColor: T, color: w } = ty(
                P ? ay(R, s) : null
              );
              return /* @__PURE__ */ b.jsx(
                Ut,
                {
                  cell: { id: _, value: R, format: S },
                  dimmed: c(_),
                  background: T,
                  tooltipProps: {
                    enabled: P,
                    title: `${f.label}, ${m.label}`,
                    metrics: C?.length ? C : [
                      {
                        type: "metric",
                        title: "Total",
                        data: R,
                        format: S === "count" ? "number" : S
                      }
                    ]
                  },
                  textProps: { color: w },
                  onMouseEnter: () => l(P ? { id: _, value: R } : null)
                },
                _.join(",")
              );
            })
          ] }, f.label);
        })
      ]
    }
  );
}, iy = "_legend_1k9xu_54", oy = "_trigger_1k9xu_58", sy = "_popover_1k9xu_64", cy = "_breakdown_1k9xu_83", Wt = {
  legend: iy,
  trigger: oy,
  popover: sy,
  breakdown: cy
}, s0 = ye(function({
  instrument: t
}) {
  const {
    data: { availability: r, media_type: n, away: a }
  } = t, i = [
    "var(--dixa-color-purple-700)",
    "var(--dixa-color-neutral-200)"
  ], o = "No data available", s = {
    // Primitive way to ensure the labels are the same width, by deriving it from the longest
    // The number 7 is roughly the average width of a lowercase character
    labelWidth: Math.max(...n.map((l) => l.label.length)) * 7,
    theme: i
  }, c = () => /* @__PURE__ */ b.jsx(
    Jt,
    {
      ...s,
      value: 0,
      label: "n.a.",
      theme: ["var(--dixa-color-neutral-200)", "var(--dixa-color-neutral-200)"],
      showFullBar: !0
    }
  ), u = () => {
    if (!a || !a.length) return null;
    const [l, d, ...f] = a;
    return /* @__PURE__ */ b.jsxs(mf, { children: [
      /* @__PURE__ */ b.jsx(bf, { asChild: !0, children: /* @__PURE__ */ b.jsx(
        io,
        {
          variant: "tertiary",
          icon: "dots-h",
          className: Wt.trigger
        }
      ) }),
      /* @__PURE__ */ b.jsx(yf, { children: /* @__PURE__ */ b.jsx(_f, { side: "right", className: Wt.popover, children: /* @__PURE__ */ b.jsxs("ul", { className: Wt.breakdown, children: [
        /* @__PURE__ */ b.jsxs("li", { children: [
          /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "1", children: l.label }),
          /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "1", children: Ue(l.value) })
        ] }),
        /* @__PURE__ */ b.jsxs("li", { children: [
          /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "2", subdued: !0, children: d.label }),
          /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "2", subdued: !0, children: Ue(d.value) })
        ] }),
        /* @__PURE__ */ b.jsx(hd, {}),
        f.map((g, p) => /* @__PURE__ */ b.jsxs("li", { children: [
          /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "2", children: g.label }),
          /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "1", children: Ue(g.value) })
        ] }, p))
      ] }) }) })
    ] });
  }, h = () => /* @__PURE__ */ b.jsxs(J, { gap: "300", className: Wt.legend, children: [
    r.map((l, d) => /* @__PURE__ */ b.jsxs(J, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ b.jsx(
        oo,
        {
          width: "6px",
          height: "6px",
          background: i[d],
          borderRadius: "50%"
        }
      ),
      /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "4", children: l.label })
    ] }, d)),
    u()
  ] });
  return /* @__PURE__ */ b.jsxs(J, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ b.jsxs(J, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "4", subdued: !0, children: r.length ? "Availability" : o }),
      r.length ? /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
        h(),
        /* @__PURE__ */ b.jsx(
          Jt,
          {
            ...s,
            value: r[0].value,
            label: "Total",
            showFullBar: !0,
            showDifference: !0
          }
        )
      ] }) : c()
    ] }),
    /* @__PURE__ */ b.jsxs(J, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "4", subdued: !0, children: n.length ? "Availability per channel" : o }),
      n.length > 0 ? /* @__PURE__ */ b.jsx(J, { flexDirection: "column", gap: "200", children: n.map((l, d) => /* @__PURE__ */ V(
        Jt,
        {
          ...s,
          key: d,
          value: l.value,
          label: l.label
        }
      )) }) : c()
    ] })
  ] });
}), uy = "_tooltip_h4i5v_1", ly = "_trigger_h4i5v_5", sl = {
  tooltip: uy,
  trigger: ly
}, fy = ({
  text: e
}) => /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
  /* @__PURE__ */ b.jsx("span", { children: e }),
  /* @__PURE__ */ b.jsx(
    Et,
    {
      className: sl.tooltip,
      content: e,
      wrap: "div",
      wrapProps: { className: sl.trigger }
    }
  )
] }), dy = ye(
  function({
    value: t
  }) {
    const [r, ...n] = t;
    return /* @__PURE__ */ b.jsxs(J, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "2", as: "span", children: r }),
      n.length > 0 && /* @__PURE__ */ b.jsx(Et, { content: n.join(", "), children: /* @__PURE__ */ b.jsxs(Y.ExternalLink, { as: "span", children: [
        "+ ",
        n.length,
        " more"
      ] }) })
    ] });
  }
), hy = ({
  cell: e,
  format: t,
  timezone: r,
  customFormats: n
}) => {
  const a = W(() => {
    if (!e || py(e.value))
      return /* @__PURE__ */ b.jsx(Y.Paragraph, { variant: "2", color: "neutral.500", children: "n.a." });
    const { value: i, label: o } = e;
    if (o) return o;
    if (n?.[t])
      return n[t]?.({ value: i });
    switch (t) {
      case "boolean":
        return i ? "Y" : "N";
      case "date":
        return ut.tz(i, r).format("L, LT");
      case "count":
        return xf(i);
      case "number":
        return Ge(i);
      case "percentage":
        return `${Ge(i)}%`;
      case "duration":
        return Ue(i);
      case "csid":
        return `#${i}`;
      case "rating":
        return `${i}`;
      case "presence":
        return /* @__PURE__ */ b.jsx(Jt, { value: i, showFullBar: !0 });
      case "tags":
        return /* @__PURE__ */ b.jsx(Ld, { tags: i, limit: 1 });
      case "text":
        return /* @__PURE__ */ b.jsx(fy, { text: i });
      case "list":
        return /* @__PURE__ */ b.jsx(dy, { value: i });
      default:
        return `${i}`;
    }
  }, [e, n, t, r]);
  return e?.ui?.type === "badge" ? /* @__PURE__ */ b.jsx(pd, { variant: e.ui.variant, size: "medium", children: /* @__PURE__ */ b.jsx(b.Fragment, { children: a }) }) : /* @__PURE__ */ b.jsx(b.Fragment, { children: a });
};
function py(e) {
  const t = e === null, r = typeof e == "string" && e.trim() === "", n = Array.isArray(e) && !e.length;
  return t || r || n;
}
const vy = "_tableWrapper_1xmkm_1", gy = "_tableWrapperEmpty_1xmkm_4", my = "_thCell_1xmkm_8", by = "_tdCell_1xmkm_12", yy = "_tooltip_1xmkm_20", _t = {
  tableWrapper: vy,
  tableWrapperEmpty: gy,
  thCell: my,
  tdCell: by,
  tooltip: yy
};
var $i, cl;
function _y() {
  if (cl) return $i;
  cl = 1;
  function e(t) {
    return t == null;
  }
  return $i = e, $i;
}
var xy = _y();
const wy = /* @__PURE__ */ Re(xy);
var Pi, ul;
function Cy() {
  if (ul) return Pi;
  ul = 1;
  var e = kf(), t = Ao(), r = 1, n = 2;
  function a(i, o, s, c) {
    var u = s.length, h = u, l = !c;
    if (i == null)
      return !h;
    for (i = Object(i); u--; ) {
      var d = s[u];
      if (l && d[2] ? d[1] !== i[d[0]] : !(d[0] in i))
        return !1;
    }
    for (; ++u < h; ) {
      d = s[u];
      var f = d[0], g = i[f], p = d[1];
      if (l && d[2]) {
        if (g === void 0 && !(f in i))
          return !1;
      } else {
        var m = new e();
        if (c)
          var y = c(g, p, f, i, o, m);
        if (!(y === void 0 ? t(p, g, r | n, c, m) : y))
          return !1;
      }
    }
    return !0;
  }
  return Pi = a, Pi;
}
var Ei, ll;
function zf() {
  if (ll) return Ei;
  ll = 1;
  var e = Je();
  function t(r) {
    return r === r && !e(r);
  }
  return Ei = t, Ei;
}
var Oi, fl;
function Ry() {
  if (fl) return Oi;
  fl = 1;
  var e = zf(), t = Oo();
  function r(n) {
    for (var a = t(n), i = a.length; i--; ) {
      var o = a[i], s = n[o];
      a[i] = [o, s, e(s)];
    }
    return a;
  }
  return Oi = r, Oi;
}
var Ai, dl;
function Uf() {
  if (dl) return Ai;
  dl = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return Ai = e, Ai;
}
var Ti, hl;
function Sy() {
  if (hl) return Ti;
  hl = 1;
  var e = Cy(), t = Ry(), r = Uf();
  function n(a) {
    var i = t(a);
    return i.length == 1 && i[0][2] ? r(i[0][0], i[0][1]) : function(o) {
      return o === a || e(o, a, i);
    };
  }
  return Ti = n, Ti;
}
var qi, pl;
function $y() {
  if (pl) return qi;
  pl = 1;
  var e = Cr();
  function t(r, n, a) {
    var i = r == null ? void 0 : e(r, n);
    return i === void 0 ? a : i;
  }
  return qi = t, qi;
}
var ji, vl;
function Py() {
  if (vl) return ji;
  vl = 1;
  var e = Ao(), t = $y(), r = Ff(), n = xo(), a = zf(), i = Uf(), o = It(), s = 1, c = 2;
  function u(h, l) {
    return n(h) && a(l) ? i(o(h), l) : function(d) {
      var f = t(d, h);
      return f === void 0 && f === l ? r(d, h) : e(l, f, s | c);
    };
  }
  return ji = u, ji;
}
var Ii, gl;
function Ey() {
  if (gl) return Ii;
  gl = 1;
  var e = Cr();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return Ii = t, Ii;
}
var Mi, ml;
function Oy() {
  if (ml) return Mi;
  ml = 1;
  var e = Of(), t = Ey(), r = xo(), n = It();
  function a(i) {
    return r(i) ? e(n(i)) : t(i);
  }
  return Mi = a, Mi;
}
var Di, bl;
function Ay() {
  if (bl) return Di;
  bl = 1;
  var e = Sy(), t = Py(), r = Rr(), n = Se(), a = Oy();
  function i(o) {
    return typeof o == "function" ? o : o == null ? r : typeof o == "object" ? n(o) ? t(o[0], o[1]) : e(o) : a(o);
  }
  return Di = i, Di;
}
var Fi, yl;
function Ty() {
  if (yl) return Fi;
  yl = 1;
  function e(t) {
    return function(r, n, a) {
      for (var i = -1, o = Object(r), s = a(r), c = s.length; c--; ) {
        var u = s[t ? c : ++i];
        if (n(o[u], u, o) === !1)
          break;
      }
      return r;
    };
  }
  return Fi = e, Fi;
}
var Ni, _l;
function qy() {
  if (_l) return Ni;
  _l = 1;
  var e = Ty(), t = e();
  return Ni = t, Ni;
}
var ki, xl;
function jy() {
  if (xl) return ki;
  xl = 1;
  var e = qy(), t = Oo();
  function r(n, a) {
    return n && e(n, a, t);
  }
  return ki = r, ki;
}
var Li, wl;
function Iy() {
  if (wl) return Li;
  wl = 1;
  var e = Eo();
  function t(r, n) {
    return function(a, i) {
      if (a == null)
        return a;
      if (!e(a))
        return r(a, i);
      for (var o = a.length, s = n ? o : -1, c = Object(a); (n ? s-- : ++s < o) && i(c[s], s, c) !== !1; )
        ;
      return a;
    };
  }
  return Li = t, Li;
}
var Bi, Cl;
function My() {
  if (Cl) return Bi;
  Cl = 1;
  var e = jy(), t = Iy(), r = t(e);
  return Bi = r, Bi;
}
var Vi, Rl;
function Dy() {
  if (Rl) return Vi;
  Rl = 1;
  var e = My(), t = Eo();
  function r(n, a) {
    var i = -1, o = t(n) ? Array(n.length) : [];
    return e(n, function(s, c, u) {
      o[++i] = a(s, c, u);
    }), o;
  }
  return Vi = r, Vi;
}
var Hi, Sl;
function Fy() {
  if (Sl) return Hi;
  Sl = 1;
  function e(t, r) {
    var n = t.length;
    for (t.sort(r); n--; )
      t[n] = t[n].value;
    return t;
  }
  return Hi = e, Hi;
}
var zi, $l;
function Ny() {
  if ($l) return zi;
  $l = 1;
  var e = jt();
  function t(r, n) {
    if (r !== n) {
      var a = r !== void 0, i = r === null, o = r === r, s = e(r), c = n !== void 0, u = n === null, h = n === n, l = e(n);
      if (!u && !l && !s && r > n || s && c && h && !u && !l || i && c && h || !a && h || !o)
        return 1;
      if (!i && !s && !l && r < n || l && a && o && !i && !s || u && a && o || !c && o || !h)
        return -1;
    }
    return 0;
  }
  return zi = t, zi;
}
var Ui, Pl;
function ky() {
  if (Pl) return Ui;
  Pl = 1;
  var e = Ny();
  function t(r, n, a) {
    for (var i = -1, o = r.criteria, s = n.criteria, c = o.length, u = a.length; ++i < c; ) {
      var h = e(o[i], s[i]);
      if (h) {
        if (i >= u)
          return h;
        var l = a[i];
        return h * (l == "desc" ? -1 : 1);
      }
    }
    return r.index - n.index;
  }
  return Ui = t, Ui;
}
var Wi, El;
function Ly() {
  if (El) return Wi;
  El = 1;
  var e = Sf(), t = Cr(), r = Ay(), n = Dy(), a = Fy(), i = _o(), o = ky(), s = Rr(), c = Se();
  function u(h, l, d) {
    l.length ? l = e(l, function(p) {
      return c(p) ? function(m) {
        return t(m, p.length === 1 ? p[0] : p);
      } : p;
    }) : l = [s];
    var f = -1;
    l = e(l, i(r));
    var g = n(h, function(p, m, y) {
      var _ = e(l, function(R) {
        return R(p);
      });
      return { criteria: _, index: ++f, value: p };
    });
    return a(g, function(p, m) {
      return o(p, m, d);
    });
  }
  return Wi = u, Wi;
}
var Gi, Ol;
function By() {
  if (Ol) return Gi;
  Ol = 1;
  var e = Ly(), t = Se();
  function r(n, a, i, o) {
    return n == null ? [] : (t(a) || (a = a == null ? [] : [a]), i = o ? void 0 : i, t(i) || (i = i == null ? [] : [i]), e(n, a, i));
  }
  return Gi = r, Gi;
}
var Vy = By();
const Hy = /* @__PURE__ */ Re(Vy), zy = (e) => typeof e == "string" || typeof e == "number" || typeof e == "boolean", Al = (e, t) => {
  const r = e.cells.find((n) => n.column === t.key);
  return !r || r.value === null ? null : (zy(r.value), r.value);
}, Uy = ({
  data: { columns: e, rows: t },
  limit: r = 50,
  sortStatus: n
}) => {
  const i = Math.ceil(t.length / r), [o, s] = te(1);
  Ot(() => {
    o !== 1 && s(1);
  }, [n, i]);
  const c = W(() => {
    if (!n) return t;
    const h = e.find(({ key: l }) => l === n.sortBy);
    return h ? Hy(
      t,
      [
        (l) => !wy(Al(l, h)),
        (l) => Al(l, h)
      ],
      ["desc", n.direction]
    ) : t;
  }, [e, t, n]);
  return {
    rows: W(
      () => c.slice((o - 1) * r, o * r),
      [o, r, c]
    ),
    currentPage: o,
    totalPages: i,
    setPage: s
  };
}, c0 = ({
  instrument: e,
  timezone: t,
  onReadInstruments: r,
  onLoadAll: n,
  onSortChange: a,
  customFormats: i
}) => {
  const {
    title: o,
    data: s,
    data: { columns: c, options: u }
  } = e, [h, l] = te(null), d = ee(null), f = u?.limit ?? 50, { rows: g, currentPage: p, totalPages: m, setPage: y } = Uy({
    data: s,
    limit: f,
    sortStatus: h
  }), _ = s.rows.length === 0, R = !!u?.next_page, C = !R && m > 1;
  Ot(() => {
    d.current && (d.current.scrollTop = 0);
  }, [p]);
  const S = U(() => (n?.(), r({
    meta: {
      pagination: {
        limit: null
      }
    }
  })), [n, r]), P = U(
    async (T) => {
      R && await S(), l(T), a?.(T);
    },
    [S, a, R]
  );
  return /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    o && /* @__PURE__ */ b.jsx("div", { children: /* @__PURE__ */ b.jsx(Y.Heading, { variant: "heading-4", children: o }) }),
    /* @__PURE__ */ b.jsxs(
      Ce,
      {
        stickyHeader: !0,
        sortingProps: {
          sortStatus: h,
          onSortChange: P
        },
        wrapperProps: {
          className: je(_t.tableWrapper, {
            [_t.tableWrapperEmpty]: _
          })
        },
        wrapperRef: d,
        hoverable: !_,
        children: [
          /* @__PURE__ */ b.jsx(Ce.Thead, { children: /* @__PURE__ */ b.jsx(Ce.Tr, { children: c.map(({ key: T, label: w, sortable: x }) => /* @__PURE__ */ b.jsx(
            Ce.Th,
            {
              className: _t.thCell,
              columnId: x ? T : null,
              children: w
            },
            T
          )) }) }),
          /* @__PURE__ */ b.jsxs(Ce.Tbody, { children: [
            _ && /* @__PURE__ */ b.jsx(Ce.Tr, { children: /* @__PURE__ */ b.jsx(Ce.Td, { colSpan: c.length, children: /* @__PURE__ */ b.jsx(
              ql,
              {
                title: "No data available",
                description: "There is no data available for the selected period and filters.",
                icon: "th"
              }
            ) }) }),
            g.map((T, w) => {
              const x = `row-${w}`;
              return /* @__PURE__ */ b.jsx(Ce.Tr, { children: c.map(({ key: E, format: $ }, I) => {
                const A = T.cells.find((q) => q.column === E);
                return /* @__PURE__ */ b.jsx(
                  Ce.Td,
                  {
                    className: _t.tdCell,
                    children: /* @__PURE__ */ b.jsx(
                      hy,
                      {
                        cell: A,
                        format: $,
                        timezone: t,
                        customFormats: i
                      }
                    )
                  },
                  `${x}-cell-${I}`
                );
              }) }, x);
            })
          ] }),
          R && /* @__PURE__ */ b.jsx(Ce.Footer, { children: /* @__PURE__ */ b.jsxs(J, { alignItems: "center", justifyContent: "center", gap: "300", children: [
            /* @__PURE__ */ b.jsxs(J, { gap: "100", alignItems: "center", children: [
              /* @__PURE__ */ b.jsx(
                vd,
                {
                  tooltipClassName: _t.tooltip,
                  text: `By default we only load the first ${f} results. If you need to see all available results, click on the button, but beware that this may take a bit of time to load depending on the number of results.`
                }
              ),
              /* @__PURE__ */ b.jsxs(Y.Paragraph, { variant: "2", children: [
                "Showing only the ",
                /* @__PURE__ */ b.jsxs("b", { children: [
                  "first ",
                  f,
                  " results"
                ] })
              ] })
            ] }),
            /* @__PURE__ */ b.jsx(co, { variant: "secondary", onClick: S, children: "Load all results" })
          ] }) }),
          C && /* @__PURE__ */ b.jsx(Ce.Footer, { children: /* @__PURE__ */ b.jsx(J, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ b.jsx(
            gd,
            {
              pageCount: m,
              currentPage: p,
              pageRangeDisplayed: 6,
              onPageChange: y
            }
          ) }) })
        ]
      }
    )
  ] });
};
export {
  n0 as AnalyticsMenu,
  i0 as ChartInstrument,
  o0 as HeatmapInstrument,
  Cf as MetricInstrument,
  pg as MetricInstrumentData,
  ro as MetricInstrumentsGrid,
  Jt as PercentageBar,
  s0 as PresenceInstrument,
  c0 as TableInstrument,
  a0 as categorizeInstruments,
  qe as chartAppearance,
  xf as formatAbbreviateNumber,
  Tt as formatInstrumentNumber,
  Ge as formatLocalizedNumber,
  Ue as formatMillisecondsToDuration,
  vr as getChartSeriesFormat,
  pr as getChartSeriesValue,
  Zv as isAIInsightInstrument,
  Kv as isChartInstrument,
  cr as isDateLikeString,
  Yv as isHeatmapInstrument,
  Gv as isMetricInstrument,
  Jv as isPresenceInstrument,
  Xv as isTableInstrument,
  zy as isTableInstrumentDataValuePrimitive,
  st as resolveChartElementColor,
  wf as resolveInstrumentColor
};
//# sourceMappingURL=index.js.map
